import QuoteListingTable from './QuoteListingTable';
import PermissionGate from './PermissionGate';

import React, {useEffect, useState, useMemo, useRef} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faCog, faEdit,faTrash, faTrashRestoreAlt, faEllipsisH, faExternalLinkAlt, faEye, faTrashAlt, faBuilding, faCodeBranch, faIndustry, faMapMarkerAlt, faSearch, faPen } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Nav, Card, Image, Button, Table, Dropdown, ProgressBar, Pagination, ButtonGroup, OverlayTrigger, Tooltip } from '@themesberg/react-bootstrap';
import { Link, useNavigate } from "react-router-dom";

import { Routes } from "../routes";
import { pageVisits } from "../data/tables";
import transactions from "../data/transactions";
import commands from "../data/commands";

import { API_URL, END_POINT_CUSTOMERS, END_POINT_COMPANY, END_POINT_BRANCHES, END_POINT_ADMIN, END_POINT_ROLES, END_POINT_QUOTES, END_POINT_PRINCIPAL, END_POINT_PRODUCT_CATEGORIES, END_POINT_INDUSTRIES, END_POINT_SUB_INDUSTRIES, END_POINT_DEPARTMENT, END_POINT_MONTH_QUOTES } from "../const";
import axios from "axios";
import Swal from 'sweetalert2';
import { faPlus, faMinus, faExchangeAlt } from '@fortawesome/free-solid-svg-icons';

// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import { getSelectStyles } from './SearchableSelect';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { ListingGridActions } from "./ListingGridActions";
import { CustomerDetailSidebar } from "./CustomerDetailSidebar";
import { hasUserPermission, isVendorOwner } from "../utils/userPermissions";
import QuoteTransferModal from "./QuoteTransferModal";
import { readSuperAdminSession, reloadSessionPage, startVendorSession } from "../utils/authSession";

const ValueChange = ({ value, suffix }) => {
  const valueIcon = value < 0 ? faAngleDown : faAngleUp;
  const valueTxtColor = value < 0 ? "text-danger" : "text-success";

  return (
    value ? <span className={valueTxtColor}>
      <FontAwesomeIcon icon={valueIcon} />
      <span className="fw-bold ms-1">
        {Math.abs(value)}{suffix}
      </span>
    </span> : "--"
  );
};


// Dashboard overview table
export const PageVisitsTable = ({ onSummaryChange }) => {

  const [quotes, setQuotes] = useState([]);
  const [totalQuotes, setTotalQuotes] = useState([]);
  const [loading, setLoading] = useState(true); // true initially to show loader
  const [showAll, setShowAll] = useState(false); // new state for toggling view

  const rawToken = sessionStorage.getItem('quotetoken');
  const token = rawToken?.replace(/^"|"$/g, '');

  // const totalQuotes = quotes.length;
  // const totalAmount = quotes.reduce((sum, q) => sum + parseFloat(q.total || 0), 0);

  const TableRow = (props) => {
    const {
      index,
      id,
      sr_no,
      offer_no,
      system_quote_no,
      offer_date,
      customer,
      place,
      company,
      branch,
      principal,
      product_code,
      category,
      qty,
      total,
      sales_executive,
      expected_date,
      status,
      remarks,
    } = props;

    return (
      <tr>
        <td>{index + 1}</td>
        <td>{sr_no}</td>
        <td>{offer_no}</td>
        <td>{system_quote_no}</td>
        <td>{offer_date}</td>
        <td>{customer?.name}</td>
        <td>{place}</td>
        <td>{company?.name}</td>
        <td>{branch?.name}</td>
        <td>{principal?.name}</td>
        <td>{product_code}</td>
        <td>{category?.name}</td>
        <td>{qty}</td>
        <td>₹ {Number(total || 0).toLocaleString("en-IN")}</td>
        <td>{sales_executive?.name}</td>
        <td>{expected_date}</td>
        <td>{status}</td>
        <td>{remarks}</td>
      </tr>
    );
  };

  useEffect(() => {
    const fetchQuoteslist = async () => {
      try {
        const response = await axios.get(API_URL + END_POINT_QUOTES, {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data.status && Array.isArray(response.data.data)) {
          setQuotes(response.data.data);

          // const totalQuotes = response.data.data.length;
          // const totalAmount = response.data.data.reduce(
          //   (sum, q) => sum + parseFloat(q.total || 0),
          //   0
          // );
          // onSummaryChange?.({ totalQuotes, totalAmount });

        }
      } catch (error) {
        console.error('Error fetching tasks:', error);
      } finally {
        setLoading(false); // hide loader in all cases
      }
    };

    fetchQuoteslist();
  }, []);


  // useEffect(() => {
  //   const fetchMonthQuoteslist = async () => {
  //     try {
  //       const response = await axios.get(API_URL + END_POINT_MONTH_QUOTES, {
  //         headers: {
  //           Accept: 'application/json',
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });

  //       // if (response.data.status && Array.isArray(response.data.data)) {
  //       if (response.data.status && response.data.data) {
  //         setTotalQuotes(response.data.data);

  //         // const totalQuotes = response.data.total_quotes;
  //         // const totalAmount = response.data.total_amount;
  //         const { total_quotes: totalQuotes, total_amount: totalAmount } = response.data.data;
  //         onSummaryChange?.({ totalQuotes, totalAmount });

  //       }
  //     } catch (error) {
  //       console.error('Error fetching :', error);
  //     }
  //   };

  //   fetchMonthQuoteslist();
  // }, []);
  useEffect(() => {
  const fetchMonthQuoteslist = async () => {
    try {
      const response = await axios.get(API_URL + END_POINT_MONTH_QUOTES, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.status && response.data.data) {
        const data = response.data.data;

        // 👇 Dashboard ke liye pura summary bhej rahe hain
        onSummaryChange?.({
          totalQuotes: data.total_quotes,
          totalAmount: data.total_amount,
          status: {
            live: data.quotes_by_status.live,
            won: data.quotes_by_status.won,
            closed: data.quotes_by_status.closed,
            lost: data.quotes_by_status.lost,
          },
          companyAmounts: data.total_amount_by_company
        });

        // Agar table ke liye quotes list chahiye
        setTotalQuotes(data.total_quotes);
      }
    } catch (error) {
      console.error('Error fetching :', error);
    }
  };

  fetchMonthQuoteslist();
}, []);

  // Decide which quotes to show depending on showAll flag
  const displayedQuotes = showAll ? quotes.sort((a, b) => b.id - a.id) : quotes.sort((a, b) => b.id - a.id).slice(0, 5);

  return (
    <Card border="light" className="dashboard-panel overflow-hidden">
      <Card.Header className="dashboard-panel__header">
        <Row className="align-items-center">
          <Col><h5 className="dashboard-panel__title mb-0">Latest Quotes</h5></Col>
        </Row>
      </Card.Header>
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px', width: '100%' }}>
        <button type="button" disabled style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#2c82d8',
            color: 'white',
            fontWeight: 'bold',
            padding: '0.5rem 1rem',
            borderRadius: '5px',
            border: 'none',
            fontWeight: "600",
            fontSize: "15px"
        }}>
          <svg style={{ marginRight: '10px', height: '20px', width: '20px', animation: 'spin 1s linear infinite' }}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="4" style={{ opacity: 0.25 }} ></circle>
            <path fill="white" style={{ opacity: 0.75 }} d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" ></path>
          </svg>
          Processing...
        </button>

        {/* Spinner animation keyframes */}
        <style>
          {`
            @keyframes spin {
              to {
                transform: rotate(360deg);
              }
            }
            svg {
              transform-origin: center;
            }
          `}
        </style>
      </div>
      ) : (
      <Table responsive className="align-items-center table-flush">
        <thead className="thead-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col">SR Number</th>
            <th scope="col">Offer Number</th>
            <th scope="col">System Quote Number</th>
            <th scope="col">Offer Date</th>
            <th scope="col">Customer</th>
            <th scope="col">Place</th>
            <th scope="col">Company</th>
            <th scope="col">Branch</th>
            <th scope="col">Principal</th>
            <th scope="col">Product Code</th>
            <th scope="col">Category</th>
            <th scope="col">Quantity</th>
            <th scope="col">Total</th>
            <th scope="col">Sales Executive</th>
            <th scope="col">Expected Date</th>
            <th scope="col">Status</th>
            <th scope="col">Remarks</th>
          </tr>
        </thead>
        {/* <tbody>
          {displayedQuotes.map((quote) => (
              <TableRow key={`quote-${quote.id}`} {...quote} />
            ))}
        </tbody> */}
        <tbody>
          {displayedQuotes.map((pt, index) => (
            <TableRow key={`page-traffic-${pt.id}`} index={index} {...pt} />
          ))}
        </tbody>
      </Table>
      )}
    </Card>
  );
};

// customer page
export const PageTrafficTable = ({ onDataLoaded }) => {

  const [pageTraffic, setPageTraffic] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [loading, setLoading] = useState(true); // true initially to show loader
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'default' });
  const [filters, setFilters] = useState({
    name: '',
    mobile: '',
    country: '',
    state: '',
    city: '',
    pincode: '',
    address_line1: '',
    'industry_segment.name': '',
    'industry_sub_segment.name': '',
    gst: '',
  });
  const [showFilters, setShowFilters] = useState(false);

  const navigate = useNavigate();

  const rawToken = sessionStorage.getItem('quotetoken');
  const token = rawToken?.replace(/^"|"$/g, '');

  const loggedInAdmin = JSON.parse(sessionStorage.getItem('quoteadmin'));
  // const loggedInAdminId = loggedInAdmin?.id;
  // const loggedInAdminRoleId = loggedInAdmin?.role_id;


  useEffect(() => {
    const fetchCustomerslist = async () => {
      try {

        const response = await axios.get(API_URL + END_POINT_CUSTOMERS, {
          headers: {
            'Accept': 'application/json',
            Authorization: `Bearer ${token}`,
          }
        });

        if (response.data.status) {
          setPageTraffic(response.data.data);
          onDataLoaded && onDataLoaded(response.data.data);
        }

      } catch (error) {
        console.error('Error fetching tasks:', error);

      } finally {
        setLoading(false); // hide loader in all cases
      }

    };

    const timeout = setTimeout(() => {
      fetchCustomerslist();
    });
    return () => clearTimeout(timeout);

  }, []);

  const getNestedValue = (obj, path) => path.split('.').reduce((acc, key) => acc?.[key], obj);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (name, selectedOptions) => {
    const values = (selectedOptions || []).map(option => option.value).join(',');
    setFilters(prev => ({ ...prev, [name]: values }));
  };

  const clearFilters = () => {
    setFilters({
      name: '',
      mobile: '',
      country: '',
      state: '',
      city: '',
      pincode: '',
      address_line1: '',
      'industry_segment.name': '',
      'industry_sub_segment.name': '',
      gst: '',
    });
  };

  const getSortValue = (item, key) => {
    if (key === 'industry_segment') return item.industry_segment?.name || '';
    if (key === 'industry_sub_segment') return item.industry_sub_segment?.name || '';
    return item[key] ?? '';
  };

  const filteredCustomers = useMemo(() => {
    let data = pageTraffic.filter(item => {
      for (const key in filters) {
        const filterValue = filters[key]?.toString().trim().toLowerCase();
        if (!filterValue) continue;

        const actualValue = getNestedValue(item, key);
        if (actualValue == null || actualValue === '') return false;

        const lowerVal = actualValue.toString().toLowerCase();
        if (filterValue.includes(',') || filterValue.includes('|')) {
          const values = filterValue.split(/[,|]/).map(s => s.trim().toLowerCase());
          if (!values.some(val => lowerVal.includes(val))) return false;
        } else if (!lowerVal.includes(filterValue)) {
          return false;
        }
      }
      return true;
    });

    if (sortConfig.direction !== 'default' && sortConfig.key && sortConfig.key !== 'serial') {
      data = [...data].sort((a, b) => {
        const valA = getSortValue(a, sortConfig.key);
        const valB = getSortValue(b, sortConfig.key);
        if (valA == null || valA === '') return 1;
        if (valB == null || valB === '') return -1;
        if (typeof valA === 'string') return valA.localeCompare(valB);
        return valA > valB ? 1 : valA < valB ? -1 : 0;
      });
      if (sortConfig.direction === 'desc') data.reverse();
    }

    return data;
  }, [pageTraffic, filters, sortConfig]);

  const selectedCustomerIndex = filteredCustomers.findIndex(customer => customer.id === selectedCustomerId);
  const selectedCustomer = filteredCustomers[selectedCustomerIndex] || null;
  const canEditCustomer = hasUserPermission('customers', 'edit', loggedInAdmin);
  const canDeleteCustomer = hasUserPermission('customers', 'delete', loggedInAdmin);

  useEffect(() => {
    if (selectedCustomerId !== null && selectedCustomerIndex < 0) setSelectedCustomerId(null);
  }, [selectedCustomerId, selectedCustomerIndex]);

  const uniqueFilterOptions = (path) => {
    const values = [...new Set(
      pageTraffic
        .map(customer => getNestedValue(customer, path))
        .filter(Boolean)
    )].sort((a, b) => a.toString().localeCompare(b.toString()));

    return values.map(value => ({ value: value.toString(), label: value.toString() }));
  };

  const filterConfig = [
    { label: 'Customer Name', name: 'name' },
    { label: 'Mobile No.', name: 'mobile' },
    { label: 'Country', name: 'country', options: uniqueFilterOptions('country') },
    { label: 'State', name: 'state', options: uniqueFilterOptions('state') },
    { label: 'City', name: 'city', options: uniqueFilterOptions('city') },
    { label: 'Pincode', name: 'pincode' },
    { label: 'Address', name: 'address_line1' },
    { label: 'Industry Segment', name: 'industry_segment.name', options: uniqueFilterOptions('industry_segment.name') },
    { label: 'Industry Sub Segment', name: 'industry_sub_segment.name', options: uniqueFilterOptions('industry_sub_segment.name') },
    { label: 'GST No.', name: 'gst' },
  ];

  const activeFilterCount = Object.values(filters).filter(value => value?.toString().trim()).length;

  // ==========================
  // Export Handlers
  // ==========================

  const exportAsPDF = () => {
    // const doc = new jsPDF();
    // const doc = new jsPDF("l", "mm", "a4");
    const doc = new jsPDF("l", "mm", "a3");
    doc.setFontSize(14);
    doc.text("Customer Data", 14, 10);

    const tableColumn = [
      "Sr No",
      "Customer Name",
      "Mobile No.",
      "Country",
      "State",
      "City",
      "Pincode",
      "Address",
      "Industry Segment",
      "Sub Segment",
      "GST No.",
    ];

    const tableRows = filteredCustomers.map((cust, index) => [
      index + 1,
      cust.name || "-",
      cust.mobile || "-",
      cust.country || "-",
      cust.state || "-",
      cust.city || "-",
      cust.pincode || "-",
      cust.address_line1 || "-",
      cust.industry_segment?.name || "-",
      cust.industry_sub_segment?.name || "-",
      cust.gst || "-",
    ]);

    autoTable(doc,{
      head: [tableColumn],
  body: tableRows,
  startY: 20,
  theme: "grid",
  headStyles: {
    fillColor: [41, 128, 185],
    textColor: [255, 255, 255],
    halign: "center",
  },
  styles: {
    fontSize: 9,
    cellPadding: 3,
    overflow: "linebreak",
  },
  columnStyles: {
    0: { cellWidth: 12 },   // Sr No
    1: { cellWidth: 50 },   // Customer Name
    2: { cellWidth: 30 },   // Mobile
    3: { cellWidth: 25 },   // Country
    4: { cellWidth: 25 },   // State
    5: { cellWidth: 30 },   // City
    6: { cellWidth: 25 },   // Pincode
    7: { cellWidth: 60 },   // Address
    8: { cellWidth: 35 },   // Industry Segment
    9: { cellWidth: 35 },   // Sub Segment
    10: { cellWidth: 40 },  // GST
  },
    });

    doc.save("customers.pdf");
  };

  const escapeXML = (unsafe) => {
  if (!unsafe) return "";
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;");
};

  // const exportAsXML = () => {
  //   let xml = `<?xml version="1.0" encoding="UTF-8"?>\n<customers>\n`;

  //   pageTraffic.forEach((cust) => {
  //     xml += `  <customer>\n`;
  //     xml += `    <name>${cust.name || ""}</name>\n`;
  //     xml += `    <mobile>${cust.mobile || ""}</mobile>\n`;
  //     xml += `    <country>${cust.country || ""}</country>\n`;
  //     xml += `    <state>${cust.state || ""}</state>\n`;
  //     xml += `    <city>${cust.city || ""}</city>\n`;
  //     xml += `    <pincode>${cust.pincode || ""}</pincode>\n`;
  //     xml += `    <address>${cust.address_line1 || ""}</address>\n`;
  //     xml += `    <industry_segment>${cust.industry_segment?.name || ""}</industry_segment>\n`;
  //     xml += `    <industry_sub_segment>${cust.industry_sub_segment?.name || ""}</industry_sub_segment>\n`;
  //     xml += `    <gst>${cust.gst || ""}</gst>\n`;
  //     xml += `  </customer>\n`;
  //   });

  //   xml += `</customers>`;

  //   const blob = new Blob([xml], { type: "application/xml" });
  //   const link = document.createElement("a");
  //   link.href = URL.createObjectURL(blob);
  //   link.download = "customers.xml";
  //   link.click();
  // };

  const exportAsXML = () => {
  let xml = '<?xml version="1.0" encoding="UTF-8"?>\n<customers>\n';

  filteredCustomers.forEach((cust, index) => {
    xml += `  <customer id="${index + 1}">\n`;
    xml += `    <name>${escapeXML(cust.name)}</name>\n`;
    xml += `    <mobile>${escapeXML(cust.mobile)}</mobile>\n`;
    xml += `    <country>${escapeXML(cust.country)}</country>\n`;
    xml += `    <state>${escapeXML(cust.state)}</state>\n`;
    xml += `    <city>${escapeXML(cust.city)}</city>\n`;
    xml += `    <pincode>${escapeXML(cust.pincode)}</pincode>\n`;
    xml += `    <address>${escapeXML(cust.address_line1)}</address>\n`;
    xml += `    <industrySegment>${escapeXML(cust.industry_segment?.name)}</industrySegment>\n`;
    xml += `    <subSegment>${escapeXML(cust.industry_sub_segment?.name)}</subSegment>\n`;
    xml += `    <gst>${escapeXML(cust.gst)}</gst>\n`;
    xml += "  </customer>\n";
  });

  xml += "</customers>";

  const blob = new Blob([xml], { type: "application/xml" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "customers.xml";
  link.click();
};

  useEffect(() => {
    if (onDataLoaded) {
      onDataLoaded(filteredCustomers, { exportAsPDF, exportAsXML });
    }
  }, [filteredCustomers]);

  const handleDelete = async (id) => {

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this customer',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: 'Deleting...',
        text: 'Please wait while we delete the customer.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
    });

    try {
      await axios.delete(`${API_URL + END_POINT_CUSTOMERS}/${id}`, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        }
      });

      Swal.fire({
        icon: 'success',
        title: 'Deleted!',
        text: 'Customer has been deleted successfully.',
      });
      // Filter out the deleted customer from state
      setPageTraffic(prev => prev.filter(customer => customer.id !== id));

    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Failed!',
        text: error.response?.data?.message || 'Failed to delete customer.',
      });
    }}
  };

  const handleEdit = (id) => {
    navigate(`/edit/customer/${id}`);
  }

  // Handle sort toggle
const handleSort = (key) => {
  setSortConfig(prev => {
    if (prev.key === key) {
      // Cycle through directions
      if (prev.direction === 'default') return { key, direction: 'asc' };
      if (prev.direction === 'asc') return { key, direction: 'desc' };
      return { key: null, direction: 'default' }; // Reset to default
    }
    return { key, direction: 'asc' }; // New column sort
  });
};

  const renderCustomerRow = ({ index, id, name, address_line1, role, address_line2, city, country, gst, industry_segment, industry_sub_segment, mobile, pincode, state, sourceIcon,  sourceIconColor})  => {

    return (
      <tr key={id} tabIndex={0} aria-label={"Customer " + name} style={{ cursor: 'pointer' }}
        onClick={event => {
          if (!event.target.closest('button, a, input, select, textarea')) setSelectedCustomerId(id);
        }}
        onKeyDown={event => {
          if (event.target === event.currentTarget && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            setSelectedCustomerId(id);
          }
        }}>
        {/* <td>
          <Card.Link href="#" className="text-primary fw-bold">{id}</Card.Link>
        </td> */}
        <td>
          <span className="text-primary fw-bold">{sortConfig.direction === 'desc' && sortConfig.key === 'serial'
            ? filteredCustomers.length - index 
            : index + 1}
          </span>
        </td>
        <td className="fw-bold">
          {sourceIcon && <FontAwesomeIcon icon={sourceIcon} className={`icon icon-xs text-${sourceIconColor} w-30`} />}
          <Button variant="link" className="p-0 text-primary fw-bold text-start" onClick={() => setSelectedCustomerId(id)} aria-label={"View customer " + name}>{name}</Button>
        </td>
        <td>{mobile}</td>
        <td>{country}</td>
        <td>{state}</td>
        <td>{city}</td>
        <td>{pincode}</td>
        <td>{address_line1}</td>
        <td>{industry_segment?.name || '-'}</td>
        <td>{industry_sub_segment?.name || '-'}</td>
        <td>{gst}</td>
        <td className="text-end">
          {canEditCustomer && <Button variant="link" className="p-0 text-success me-3 box-shedow-none outline-none" onClick={() => handleEdit(id)} aria-label={"Edit customer " + name}>
            <FontAwesomeIcon icon={faEdit} />
          </Button>}
          {canDeleteCustomer && <Button variant="link" className="p-0 text-danger box-shedow-none outline-none" onClick={() => handleDelete(id)} aria-label={"Delete customer " + name}>
            <FontAwesomeIcon icon={faTrash} />
          </Button>}
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="overflow-hidden border-radius-5">
      <Card.Body className="pb-0 p-0">
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px', width: '100%' }}>
        <button type="button" disabled style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#2c82d8',
            color: 'white',
            fontWeight: 'bold',
            padding: '0.5rem 1rem',
            borderRadius: '5px',
            border: 'none',
            fontWeight: "600",
            fontSize: "15px"
        }}>
          <svg style={{ marginRight: '10px', height: '20px', width: '20px', animation: 'spin 1s linear infinite' }}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="4" style={{ opacity: 0.25 }} ></circle>
            <path fill="white" style={{ opacity: 0.75 }} d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
          </svg>
          Processing...
        </button>
    
        {/* Spinner animation keyframes */}
        <style>
          {`
            @keyframes spin {
              to {
                transform: rotate(360deg);
              }
            }
            svg {
              transform-origin: center;
            }
          `}
        </style>
      </div>
      ) : (
        <>
          <div className="px-3 pt-3 mb-4">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div className="d-flex align-items-center gap-2">
                <h5 className="mb-0 font-20 text-quote-dark">Filters</h5>
                {activeFilterCount > 0 && (
                  <span className="badge bg-primary">{activeFilterCount} active</span>
                )}
              </div>
              <div className="d-flex align-items-center gap-2">
                {activeFilterCount > 0 && (
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={clearFilters}
                  >
                    Clear Filters
                  </button>
                )}
                <button
                  type="button"
                  className="btn-quote-blue d-inline-flex align-items-center py-2 px-2 btn btn-primary box-shedow-none outline-none"
                  onClick={() => setShowFilters(prev => !prev)}
                >
                  {showFilters ? <FontAwesomeIcon icon={faMinus} /> : <FontAwesomeIcon icon={faPlus} />}
                </button>
              </div>
            </div>

            {showFilters && (
              <div className="row g-3 border-top mt-3 pt-3">
                {filterConfig.map(({ label, name, options }) => (
                  <div className="col-md-3" key={name}>
                    <label>{label}</label>
                    {options ? (
                      <Select
                        isMulti
                        options={options}
                        value={options.filter(option =>
                          (filters[name] || '').split(',').filter(Boolean).includes(option.value)
                        )}
                        onChange={(selected) => handleSelectChange(name, selected)}
                        menuPortalTarget={document.body}
                        styles={getSelectStyles()}
                      />
                    ) : (
                      <input
                        type="text"
                        name={name}
                        value={filters[name] || ''}
                        onChange={handleFilterChange}
                        className="form-control"
                      />
                    )}
                  </div>
                ))}
              </div>
            )}

            <div className="text-muted small mt-2">
              Showing {filteredCustomers.length} of {pageTraffic.length} customers
            </div>
          </div>

          <Table responsive className="table-centered table-nowrap rounded mb-0">
            <thead className="thead-light">
              <tr>
                <th
                  className="border-0"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleSort('serial')}
                >
                  #
                  {sortConfig.key === 'serial' && (sortConfig.direction === 'asc' ? ' 🔼' : sortConfig.direction === 'desc' ? ' 🔽' : '')}
                </th>
                <th className="border-0" onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>
                  Customer name {sortConfig.key === 'name' ? (sortConfig.direction === 'asc' ? ' 🔼' : sortConfig.direction === 'desc' ? ' 🔽' : '') : ''}
                </th>
                <th className="border-0" onClick={() => handleSort('mobile')} style={{ cursor: 'pointer' }}>
                  Mobile no. {sortConfig.key === 'mobile' ? (sortConfig.direction === 'asc' ? ' 🔼' : sortConfig.direction === 'desc' ? ' 🔽' : '') : ''}
                </th>
                <th className="border-0" onClick={() => handleSort('country')} style={{ cursor: 'pointer' }}>
                  Country {sortConfig.key === 'country' ? (sortConfig.direction === 'asc' ? ' 🔼' : sortConfig.direction === 'desc' ? ' 🔽' : '') : ''}
                </th>
                <th className="border-0" onClick={() => handleSort('state')} style={{ cursor: 'pointer' }}>
                  State {sortConfig.key === 'state' ? (sortConfig.direction === 'asc' ? ' 🔼' : sortConfig.direction === 'desc' ? ' 🔽' : '') : ''}
                </th>
                <th className="border-0" onClick={() => handleSort('city')} style={{ cursor: 'pointer' }}>
                  City {sortConfig.key === 'city' ? (sortConfig.direction === 'asc' ? ' 🔼' : sortConfig.direction === 'desc' ? ' 🔽' : '') : ''}
                </th>
                <th className="border-0" onClick={() => handleSort('pincode')} style={{ cursor: 'pointer' }}>
                  Pincode {sortConfig.key === 'pincode' ? (sortConfig.direction === 'asc' ? ' 🔼' : sortConfig.direction === 'desc' ? ' 🔽' : '') : ''}
                </th>
                <th className="border-0" onClick={() => handleSort('address_line1')} style={{ cursor: 'pointer' }}>
                  Address {sortConfig.key === 'address_line1' ? (sortConfig.direction === 'asc' ? ' 🔼' : sortConfig.direction === 'desc' ? ' 🔽' : '') : ''}
                </th>
                <th className="border-0" onClick={() => handleSort('industry_segment')} style={{ cursor: 'pointer' }}>
                  Industry Segment {sortConfig.key === 'industry_segment' ? (sortConfig.direction === 'asc' ? ' 🔼' : sortConfig.direction === 'desc' ? ' 🔽' : '') : ''}
                </th>
                <th className="border-0" onClick={() => handleSort('industry_sub_segment')} style={{ cursor: 'pointer' }}>
                  Industry Sub Segment {sortConfig.key === 'industry_sub_segment' ? (sortConfig.direction === 'asc' ? ' 🔼' : sortConfig.direction === 'desc' ? ' 🔽' : '') : ''}
                </th>
                <th className="border-0" onClick={() => handleSort('gst')} style={{ cursor: 'pointer' }}>
                  GST no. {sortConfig.key === 'gst' ? (sortConfig.direction === 'asc' ? ' 🔼' : sortConfig.direction === 'desc' ? ' 🔽' : '') : ''}
                </th>
                <th className="border-0 text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredCustomers.length > 0 ? (
                filteredCustomers.map((customer, index) => renderCustomerRow({ ...customer, index }))
              ) : (
                <tr>
                  <td colSpan={12} className="text-center text-muted py-4">
                    No customers match the selected filters.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </>
      )}
      </Card.Body>
      <CustomerDetailSidebar
        customer={selectedCustomer}
        show={selectedCustomer !== null}
        onClose={() => setSelectedCustomerId(null)}
        onEdit={handleEdit}
        onDelete={handleDelete}
        canEdit={canEditCustomer}
        canDelete={canDeleteCustomer}
        onPrevious={() => setSelectedCustomerId(filteredCustomers[selectedCustomerIndex - 1]?.id ?? null)}
        onNext={() => setSelectedCustomerId(filteredCustomers[selectedCustomerIndex + 1]?.id ?? null)}
        hasPrevious={selectedCustomerIndex > 0}
        hasNext={selectedCustomerIndex >= 0 && selectedCustomerIndex < filteredCustomers.length - 1}
      />
    </Card>
  );
};


// company page 
export const PageCompanyTable = ({ viewMode = "grid", refreshKey = 0, onEditCompany }) => {

  const [pageCompany, setPageCompany] = useState([]);
  const [loading, setLoading] = useState(true); // true initially to show loader
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'default' });

  const rawToken = sessionStorage.getItem('quotetoken');
  const token = rawToken?.replace(/^"|"$/g, '');

  // const loggedInSuperAdmin = JSON.parse(sessionStorage.getItem('quoteadmin'));
  const loggedInAdmin = JSON.parse(sessionStorage.getItem('quoteadmin'));

  const navigate = useNavigate();


  useEffect(() => {
    let active = true;
    setLoading(true);
    const fetchCompanylist = async () => {
      try {

        const response = await axios.get(API_URL + END_POINT_COMPANY, {
          headers: {
            // 'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            Authorization: `Bearer ${token}`,

          }
        });

        // if (response.data?.status && response.data.data) {
        //   setPageCompany(response.data.data);
        // }
        if (active && response.data?.status && Array.isArray(response.data.data)) {
          const activeCompanies = response.data.data.filter(company => company.deleted_at === null);
          setPageCompany(activeCompanies);
        }

      } catch (error) {
        console.error('Error fetching tasks:', error);
      } finally {
        if (active) setLoading(false);
      }

    };

    const timeout = setTimeout(() => {
      fetchCompanylist();
    });
    return () => { active = false; clearTimeout(timeout); };

  }, [refreshKey, token]);

  const handleDelete = async (id) => {

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this company',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: 'Deleting...',
        text: 'Please wait while we delete the company.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
    });

    try {
      await axios.delete(`${API_URL + END_POINT_COMPANY}/${id}`, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`
        }
      });

      Swal.fire({
        icon: 'success',
        title: 'Deleted!',
        text: 'Company has been deleted successfully.',
      });
      // Filter out the deleted company from state
      setPageCompany(prev => prev.filter(company => company.id !== id));

    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Failed!',
        text: error.response?.data?.message || 'Failed to delete company.',
      });
    }
  }
  };


  const getSortedData = () => {
    const sorted = [...pageCompany];
    const { key, direction } = sortConfig;

    if (direction === 'default' || !key) return sorted;

    sorted.sort((a, b) => {
      const valA = key === 'name' ? a.name.toLowerCase() : a[key];
      const valB = key === 'name' ? b.name.toLowerCase() : b[key];

      if (valA < valB) return direction === 'asc' ? -1 : 1;
      if (valA > valB) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    return sorted;
  };

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        const nextDirection = prev.direction === 'default' ? 'asc' : prev.direction === 'asc' ? 'desc' : 'default';
        return { key, direction: nextDirection };
      } else {
        return { key, direction: 'asc' };
      }
    });
  };



  const handleEdit = (id) => {
    if (onEditCompany) onEditCompany(id);
    else navigate(`/edit/company/${id}`);
  }

  const handleCompanySettings = (id) => {
    navigate(`/company-settings/${id}`);
  }

  // const TableRow = (props) => {
    const TableRow = ({ index, id, name, address, sourceIcon, role, sourceIconColor}) => {

    const isRowSuperOrAdmin = role?.name === "Admin" || role?.name === "Super Admin";
    const isLoggedInSuperOrAdmin = loggedInAdmin?.role_name === "Admin" || loggedInAdmin?.role_name === "Super Admin";

    // const disableDelete = isCurrentUser || isRowSuperOrAdmin || !isLoggedInSuperOrAdmin;
    const disableEdit = !hasUserPermission('companies', 'edit');


    const isRowSuperOrAdminDelete = role?.name === "Admin" || role?.name === "Super Admin" || role?.name === "Internal Sales";
    const isLoggedInSuperOrAdminDelete = loggedInAdmin?.role_name === "Admin" || loggedInAdmin?.role_name === "Super Admin" || loggedInAdmin?.role_name === "Internal Sales";

    const disableDelete = !hasUserPermission('companies', 'delete');

      
    // const isRowSuperadmin = role?.name === "Super Admin";
    // const isLoggedInSuperOrAdmin = loggedInAdmin?.role_name === "Admin" || loggedInAdmin?.role_name === "Super Admin";
    // const isLoggedInSuperAdmin = loggedInSuperAdmin?.role_name === "Super Admin";

    return (
      <tr>
        {/* <td>
          <Card.Link href="#" className="text-primary fw-bold">{id}</Card.Link>
        </td> */}
        <td>
          <Card.Link href="#" className="text-primary fw-bold">{sortConfig.direction === 'desc' && sortConfig.key === 'serial' 
            ? getSortedData().length - index 
            : index + 1}
          </Card.Link>
        </td>
        <td className="fw-bold">
          <FontAwesomeIcon icon={sourceIcon} className={`icon icon-xs text-${sourceIconColor} w-30`} />
          {name}
        </td>
        <td>{address}</td>
        <td className="text-end">
          <ListingGridActions
            className="listing-table-actions"
            disableEdit={disableEdit}
            disableDelete={disableDelete}
            onEdit={() => !disableEdit && handleEdit(id)}
            onDelete={() => !disableDelete && handleDelete(id)}
            onSettings={hasUserPermission('companies', 'edit') ? () => handleCompanySettings(id) : undefined}
          />
        </td>
      </tr>
    );
  };

  const GridCard = ({ index, id, name, address, sourceIcon, role, sourceIconColor }) => {
    const isRowSuperOrAdmin = role?.name === "Admin" || role?.name === "Super Admin";
    const isLoggedInSuperOrAdmin = loggedInAdmin?.role_name === "Admin" || loggedInAdmin?.role_name === "Super Admin";
    const disableEdit = !hasUserPermission('companies', 'edit');

    const isRowSuperOrAdminDelete = role?.name === "Admin" || role?.name === "Super Admin" || role?.name === "Internal Sales";
    const isLoggedInSuperOrAdminDelete = loggedInAdmin?.role_name === "Admin" || loggedInAdmin?.role_name === "Super Admin" || loggedInAdmin?.role_name === "Internal Sales";
    const disableDelete = !hasUserPermission('companies', 'delete');

    return (
      <Col xs={12} sm={6} lg={4} xl={3}>
        <Card className="listing-grid-card listing-grid-card--company h-100">
          <div className="listing-grid-card__accent" />
          <Card.Body className="d-flex flex-column">
            <div className="listing-grid-card__header">
              <div className="listing-grid-card__icon-wrap">
                <FontAwesomeIcon icon={sourceIcon || faBuilding} />
              </div>
              <h5 className="listing-grid-card__title">{name?.toUpperCase()}</h5>
            </div>
            <div className="listing-grid-card__meta">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="listing-grid-card__meta-icon" />
              <span>{address || "No address provided"}</span>
            </div>
            <ListingGridActions
              disableEdit={disableEdit}
              disableDelete={disableDelete}
              onEdit={() => !disableEdit && handleEdit(id)}
              onDelete={() => !disableDelete && handleDelete(id)}
              onSettings={hasUserPermission('companies', 'edit') ? () => handleCompanySettings(id) : undefined}
            />
          </Card.Body>
        </Card>
      </Col>
    );
  };

  const sortedCompanies = getSortedData();

  return (
    <Card border="light" className="overflow-hidden border-radius-5 mb-4">
      <Card.Body className={viewMode === "grid" ? "p-4" : "pb-0 p-0"}>
      {loading ? (
        <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '200px',
          width: '100%',
        }}
      >
        <button
          type="button"
          disabled
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#2c82d8',
            color: 'white',
            fontWeight: 'bold',
            padding: '0.5rem 1rem',
            borderRadius: '5px',
            border: 'none',
            fontWeight: "600",
            fontSize: "15px"
          }}
        >
          <svg
            style={{
              marginRight: '10px',
              height: '20px',
              width: '20px',
              animation: 'spin 1s linear infinite',
            }}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="white"
              strokeWidth="4"
              style={{ opacity: 0.25 }}
            ></circle>
            <path
              fill="white"
              style={{ opacity: 0.75 }}
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            ></path>
          </svg>
          Processing...
        </button>
    
        {/* Spinner animation keyframes */}
        <style>
          {`
            @keyframes spin {
              to {
                transform: rotate(360deg);
              }
            }
            svg {
              transform-origin: center;
            }
          `}
        </style>
      </div>
      ) : viewMode === "grid" ? (
        sortedCompanies.length > 0 ? (
          <Row className="g-4">
            {sortedCompanies.map((company, index) => (
              <GridCard key={`company-grid-${company.id}`} index={index} {...company} />
            ))}
          </Row>
        ) : (
          <div className="listing-empty-state">No companies found.</div>
        )
      ) : (
        <Table responsive className="table-centered table-nowrap rounded mb-0">
          <thead className="thead-light">
            <tr>
              {/* <th className="border-0" onClick={() => handleSort('id')} style={{ cursor: 'pointer' }}>
                # {sortConfig.key === 'id' && (sortConfig.direction === 'asc' ? '⇧' : sortConfig.direction === 'desc' ? '⇩' : '⇅')}
              </th> */}
              <th
                className="border-0"
                style={{ cursor: 'pointer' }}
                onClick={() => handleSort('serial')}
              >
                #
                {sortConfig.key === 'serial' && (sortConfig.direction === 'asc' ? ' 🔼' : sortConfig.direction === 'desc' ? ' 🔽' : '')}
              </th>
              <th className="border-0" onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>
                Company name {sortConfig.key === 'name' && (sortConfig.direction === 'asc' ? '🔼' : sortConfig.direction === 'desc' ? '🔽' : '')}
              </th>
              <th className="border-0">Address</th>
              <th className="border-0 text-end">Actions</th>
            </tr>
          </thead>
          {/* <tbody>
            {getSortedData().map(pt => <TableRow key={`page-traffic-${pt.id}`} {...pt} />)}
          </tbody> */}
          <tbody>
            {sortedCompanies.map((pt, index) => (
              <TableRow key={`page-traffic-${pt.id}`} index={index} {...pt} />
            ))}
          </tbody>
        </Table>
      )}
      </Card.Body>
    </Card>
  );
};

// soft deleted company page 
export const SoftCompanyTable = () => {

  const [pageCompany, setPageCompany] = useState([]);
  const [loading, setLoading] = useState(true); // true initially to show loader
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'default' });

  const rawToken = sessionStorage.getItem('quotetoken');
  const token = rawToken?.replace(/^"|"$/g, '');

  const navigate = useNavigate();


  useEffect(() => {
    const fetchCompanylist = async () => {
      try {

        const response = await axios.get(API_URL + END_POINT_COMPANY, {
          headers: {
            // 'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            Authorization: `Bearer ${token}`,

          }
        });

        // if (response.data?.status && response.data.data) {
        //   setPageCompany(response.data.data);
        // }
        if (response.data?.status && response.data.data) {
          const activeCompanies = response.data.data.filter(company => company.deleted_at !== null);
          setPageCompany(activeCompanies);
        }

      } catch (error) {
        console.error('Error fetching tasks:', error);
      } finally {
        setLoading(false); // hide loader in all cases
      }

    };

    const timeout = setTimeout(() => {
      fetchCompanylist();
    });
    return () => clearTimeout(timeout);

  }, []);

  const handleDelete = async (id) => {

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this company',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: 'Deleting...',
        text: 'Please wait while we delete the company.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
    });

    try {
      await axios.delete(`${API_URL + END_POINT_COMPANY}/${id}/force`, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`
        }
      });

      Swal.fire({
        icon: 'success',
        title: 'Deleted!',
        text: 'Company has been deleted successfully.',
      });
      // Filter out the deleted company from state
      setPageCompany(prev => prev.filter(company => company.id !== id));

    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Failed!',
        text: error.response?.data?.message || 'Failed to delete company.',
      });
    }
  }
  };


  const getSortedData = () => {
    const sorted = [...pageCompany];
    const { key, direction } = sortConfig;

    if (direction === 'default' || !key) return sorted;

    sorted.sort((a, b) => {
      const valA = key === 'name' ? a.name.toLowerCase() : a[key];
      const valB = key === 'name' ? b.name.toLowerCase() : b[key];

      if (valA < valB) return direction === 'asc' ? -1 : 1;
      if (valA > valB) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    return sorted;
  };

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        const nextDirection = prev.direction === 'default' ? 'asc' : prev.direction === 'asc' ? 'desc' : 'default';
        return { key, direction: nextDirection };
      } else {
        return { key, direction: 'asc' };
      }
    });
  };



  // const handleEdit = (id) => {
  //   navigate(`/edit/company/${id}`);
  // }

  const handleRestore = async (id) => {

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will be able to recover this company',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: 'Restoring...',
        text: 'Please wait while we restore the company.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
    });

    try {
      const response = await axios.post(`${API_URL + END_POINT_COMPANY}/${id}/restore`,{}, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`
        }
      });

      Swal.fire({
        icon: 'success',
        title: 'Restored!',
        // text: 'Company has been restore successfully.',
        text: response.data?.message || 'Company has been restore successfully.',
      });
      // Filter out the restore company from state
      setPageCompany(prev => prev.filter(company => company.id !== id));

    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Failed!',
        text: error.response?.data?.message || 'Failed to restore company.',
      });
    }
  }
  };

  // const TableRow = (props) => {
    const TableRow = ({ id, name, address, sourceIcon,  sourceIconColor}) => {
    return (
      <tr>
        <td>
          <Card.Link href="#" className="text-primary fw-bold">{id}</Card.Link>
        </td>
        <td className="fw-bold">
          <FontAwesomeIcon icon={sourceIcon} className={`icon icon-xs text-${sourceIconColor} w-30`} />
          {name}
        </td>
        <td>{address}</td>
        <td className="text-end">
        <PermissionGate module="companies" action="edit"><Button variant="link" className="p-0 text-success me-3 box-shedow-none outline-none" onClick={() => handleRestore(id)}>
          <FontAwesomeIcon icon={faTrashRestoreAlt} />
        </Button></PermissionGate>
        <PermissionGate module="companies" action="delete"><Button variant="link" className="p-0 text-danger box-shedow-none outline-none" onClick={() => handleDelete(id)}>
          <FontAwesomeIcon icon={faTrash} />
        </Button></PermissionGate>
      </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="overflow-hidden border-radius-5 mb-4">
      <Card.Body className="pb-0 p-0">
      {loading ? (
        <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '200px',
          width: '100%',
        }}
      >
        <button
          type="button"
          disabled
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#2c82d8',
            color: 'white',
            fontWeight: 'bold',
            padding: '0.5rem 1rem',
            borderRadius: '5px',
            border: 'none',
            fontWeight: "600",
            fontSize: "15px"
          }}
        >
          <svg
            style={{
              marginRight: '10px',
              height: '20px',
              width: '20px',
              animation: 'spin 1s linear infinite',
            }}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="white"
              strokeWidth="4"
              style={{ opacity: 0.25 }}
            ></circle>
            <path
              fill="white"
              style={{ opacity: 0.75 }}
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            ></path>
          </svg>
          Processing...
        </button>
    
        {/* Spinner animation keyframes */}
        <style>
          {`
            @keyframes spin {
              to {
                transform: rotate(360deg);
              }
            }
            svg {
              transform-origin: center;
            }
          `}
        </style>
      </div>
      ) : pageCompany.length === 0 ? (  // Agar data nahi hai
        <div style={{ textAlign: 'center', padding: '50px', fontSize: '18px', color: '#666' }}>
          No records found.
        </div>
      ) : (
        <Table responsive className="table-centered table-nowrap rounded mb-0">
          <thead className="thead-light">
            <tr>
              <th className="border-0" onClick={() => handleSort('id')} style={{ cursor: 'pointer' }}>
                # {sortConfig.key === 'id' && (sortConfig.direction === 'asc' ? '⇧' : sortConfig.direction === 'desc' ? '⇩' : '⇅')}
              </th>
              <th className="border-0" onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>
                Company name {sortConfig.key === 'name' && (sortConfig.direction === 'asc' ? '⇧' : sortConfig.direction === 'desc' ? '⇩' : '⇅')}
              </th>
              <th className="border-0">Address</th>
              <th className="border-0 text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            {getSortedData().map(pt => <TableRow key={`page-traffic-${pt.id}`} {...pt} />)}
          </tbody>
        </Table>
      )}
      </Card.Body>
    </Card>
  );
};

// Branch Page
export const PageBranchTable = ({ viewMode = "grid", refreshKey = 0, onEditBranch }) => {

  const [pageBranch, setPageBranch] = useState([]);
  const [loading, setLoading] = useState(true); // true initially to show loader
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'default' });

  const rawToken = sessionStorage.getItem('quotetoken');
  const token = rawToken?.replace(/^"|"$/g, '');

  // const loggedInSuperAdmin = JSON.parse(sessionStorage.getItem('quoteadmin'));
  const loggedInAdmin = JSON.parse(sessionStorage.getItem('quoteadmin'));

  const navigate = useNavigate();

  useEffect(() => {
    let active = true;
    setLoading(true);
    const fetchBranchlist = async () => {
      try {

        const response = await axios.get(API_URL + END_POINT_BRANCHES, {
          headers: {
            // 'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            Authorization: `Bearer ${token}`,
          }
        });

        // if (response.data && response.data.status) {
        //   setPageBranch(response.data.data);
        // }
        if (active && response.data?.status && Array.isArray(response.data.data)) {
          const activeBranches = response.data.data.filter(branch => branch.deleted_at === null);
          setPageBranch(activeBranches);
        }

      } catch (error) {
        console.error('Error fetching tasks:', error);
      } finally {
        if (active) setLoading(false);
      }

    };

    const timeout = setTimeout(() => {
      fetchBranchlist();
    });
    return () => { active = false; clearTimeout(timeout); };

  }, [refreshKey, token]);

  const handleDelete = async (id) => {

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this branch',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: 'Deleting...',
        text: 'Please wait while we delete the branch.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
    });

    try {
      await axios.delete(`${API_URL + END_POINT_BRANCHES}/${id}`, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        }
      });
  
      Swal.fire({
        icon: 'success',
        title: 'Deleted!',
        text: 'Branch has been deleted successfully.',
      });
      // Filter out the deleted branches from state
      setPageBranch(prev => prev.filter(branch => branch.id !== id));
  
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Failed!',
        text: error.response?.data?.message || 'Failed to delete branch.',
      });
    }
  }
  };

  const handleEdit = (id) => {
    if (!hasUserPermission('branches', 'edit')) return;
    if (onEditBranch) {
      onEditBranch(id);
      return;
    }
    navigate(`/edit/branch/${id}`);
  }

  const handleSort = (key) => {
    setSortConfig(prev => {
      if (prev.key !== key) return { key, direction: 'asc' };
      if (prev.direction === 'asc') return { key, direction: 'desc' };
      if (prev.direction === 'desc') return { key: null, direction: 'default' };
      return { key, direction: 'asc' };
    });
  };

  const sortedBranches = useMemo(() => {
    if (sortConfig.direction === 'default' || !sortConfig.key) return pageBranch;
  
    const sorted = [...pageBranch].sort((a, b) => {
      const valA = a[sortConfig.key]?.toString().toLowerCase() ?? '';
      const valB = b[sortConfig.key]?.toString().toLowerCase() ?? '';
  
      if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
      if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  
    return sorted;
  }, [pageBranch, sortConfig]);
  

  const TableRow = ({ index, id, name, address, status, role, sourceIcon, sourceIconColor })  => {

    // const isLoggedInSuperAdmin = loggedInSuperAdmin?.role_name === "Super Admin";

    const isRowSuperOrAdmin = role?.name === "Admin" || role?.name === "Super Admin";
    const isLoggedInSuperOrAdmin = loggedInAdmin?.role_name === "Admin" || loggedInAdmin?.role_name === "Super Admin";

    // const disableDelete = isCurrentUser || isRowSuperOrAdmin || !isLoggedInSuperOrAdmin;
    const disableEdit = !hasUserPermission('branches', 'edit');


    const isRowSuperOrAdminDelete = role?.name === "Admin" || role?.name === "Super Admin" || role?.name === "Internal Sales";
    const isLoggedInSuperOrAdminDelete = loggedInAdmin?.role_name === "Admin" || loggedInAdmin?.role_name === "Super Admin" || loggedInAdmin?.role_name === "Internal Sales";
  
    const disableDelete = !hasUserPermission('branches', 'delete');

    return (
      <tr>
        {/* <td>
          <Card.Link href="#" className="text-primary fw-bold">{index}</Card.Link>
        </td> */}
        <td>
          <Card.Link href="#" className="text-primary fw-bold">{sortConfig.direction === 'desc' && sortConfig.key === 'serial' 
            ? sortedBranches.length - index 
            : index + 1}
          </Card.Link>
        </td>
        <td className="fw-bold">
          <FontAwesomeIcon icon={sourceIcon} className={`icon icon-xs text-${sourceIconColor} w-30`} />
          {name}
        </td>
        <td>{address}</td>
        <td className="text-end">
          <ListingGridActions
            className="listing-table-actions"
            disableEdit={disableEdit}
            disableDelete={disableDelete}
            onEdit={() => !disableEdit && handleEdit(id)}
            onDelete={() => !disableDelete && handleDelete(id)}
          />
        </td>
      </tr>
    );
  };

  const GridCard = ({ index, id, name, address, sourceIcon, role, sourceIconColor }) => {
    const isRowSuperOrAdmin = role?.name === "Admin" || role?.name === "Super Admin";
    const isLoggedInSuperOrAdmin = loggedInAdmin?.role_name === "Admin" || loggedInAdmin?.role_name === "Super Admin";
    const disableEdit = !hasUserPermission('branches', 'edit');

    const isRowSuperOrAdminDelete = role?.name === "Admin" || role?.name === "Super Admin" || role?.name === "Internal Sales";
    const isLoggedInSuperOrAdminDelete = loggedInAdmin?.role_name === "Admin" || loggedInAdmin?.role_name === "Super Admin" || loggedInAdmin?.role_name === "Internal Sales";
    const disableDelete = !hasUserPermission('branches', 'delete');

    return (
      <Col xs={12} sm={6} lg={4} xl={3}>
        <Card className="listing-grid-card listing-grid-card--branch h-100">
          <div className="listing-grid-card__accent" />
          <Card.Body className="d-flex flex-column">
            <div className="listing-grid-card__header">
              <div className="listing-grid-card__icon-wrap">
                <FontAwesomeIcon icon={sourceIcon || faCodeBranch} />
              </div>
              <h5 className="listing-grid-card__title">{name?.toUpperCase()}</h5>
            </div>
            <div className="listing-grid-card__meta">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="listing-grid-card__meta-icon" />
              <span>{address || "No address provided"}</span>
            </div>
            <ListingGridActions
              disableEdit={disableEdit}
              disableDelete={disableDelete}
              onEdit={() => !disableEdit && handleEdit(id)}
              onDelete={() => !disableDelete && handleDelete(id)}
            />
          </Card.Body>
        </Card>
      </Col>
    );
  };

  return (
    <Card border="light" className="overflow-hidden border-radius-5 mb-4">
      <Card.Body className={viewMode === "grid" ? "p-4" : "pb-0 p-0"}>
      {loading ? (
        <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '200px',
          width: '100%',
        }}
      >
        <button
          type="button"
          disabled
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#2c82d8',
            color: 'white',
            fontWeight: 'bold',
            padding: '0.5rem 1rem',
            borderRadius: '5px',
            border: 'none',
            fontWeight: "600",
            fontSize: "15px"
          }}
        >
          <svg
            style={{
              marginRight: '10px',
              height: '20px',
              width: '20px',
              animation: 'spin 1s linear infinite',
            }}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="white"
              strokeWidth="4"
              style={{ opacity: 0.25 }}
            ></circle>
            <path
              fill="white"
              style={{ opacity: 0.75 }}
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            ></path>
          </svg>
          Processing...
        </button>
    
        {/* Spinner animation keyframes */}
        <style>
          {`
            @keyframes spin {
              to {
                transform: rotate(360deg);
              }
            }
            svg {
              transform-origin: center;
            }
          `}
        </style>
      </div>
      ) : viewMode === "grid" ? (
        sortedBranches.length > 0 ? (
          <Row className="g-4">
            {sortedBranches.map((branch, index) => (
              <GridCard key={`branch-grid-${branch.id}`} index={index} {...branch} />
            ))}
          </Row>
        ) : (
          <div className="listing-empty-state">No branches found.</div>
        )
      ) : (
        <Table responsive className="table-centered table-nowrap rounded mb-0">
          <thead className="thead-light">
            <tr>
              {/* <th className="border-0">#</th>
              <th className="border-0">Branch name</th> */}
              {/* <th className="border-0" onClick={() => handleSort('serial')} style={{ cursor: 'pointer' }}>
                #
                {sortConfig.key === 'serial' && (sortConfig.direction === 'asc' ? '⇧' : sortConfig.direction === 'desc' ? '⇩' : '⇅')}
              </th> */}
              <th
                className="border-0"
                style={{ cursor: 'pointer' }}
                onClick={() => handleSort('serial')}
              >
                #
                {sortConfig.key === 'serial' && (sortConfig.direction === 'asc' ? ' 🔼' : sortConfig.direction === 'desc' ? ' 🔽' : '')}
              </th>
              <th className="border-0" onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>
                Branch name
                {sortConfig.key === 'name' && (sortConfig.direction === 'asc' ? '⇧' : sortConfig.direction === 'desc' ? '⇩' : '⇅')}
              </th>
              <th className="border-0">Address</th>
              <th className="border-0 text-end">Actions</th>
            </tr>
          </thead>
          {/* <tbody>
            {sortedBranches.map(pt => <TableRow key={`page-traffic-${pt.id}`} {...pt} />)}
          </tbody> */}
          <tbody>
            {sortedBranches.map((pt, index) => (
              <TableRow key={`page-traffic-${pt.id}`} index={index} {...pt} />
            ))}
          </tbody>
        </Table>
      )}
      </Card.Body>
    </Card>
  );
};

// Soft deleted Branch Page
export const SoftBranchTable = () => {

  const [pageBranch, setPageBranch] = useState([]);
  const [loading, setLoading] = useState(true); // true initially to show loader
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'default' });

  const rawToken = sessionStorage.getItem('quotetoken');
  const token = rawToken?.replace(/^"|"$/g, '');

  const navigate = useNavigate();

  useEffect(() => {
    const fetchBranchlist = async () => {
      try {

        const response = await axios.get(API_URL + END_POINT_BRANCHES, {
          headers: {
            // 'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            Authorization: `Bearer ${token}`,
          }
        });

        // if (response.data && response.data.status) {
        //   setPageBranch(response.data.data);
        // }
        if (response.data && response.data.status) {
          const activeBranches = response.data.data.filter(branch => branch.deleted_at !== null);
          setPageBranch(activeBranches);
        }

      } catch (error) {
        console.error('Error fetching tasks:', error);
      } finally {
        setLoading(false); // hide loader in all cases
      }

    };

    const timeout = setTimeout(() => {
      fetchBranchlist();
    });
    return () => clearTimeout(timeout);

  }, []);

  const handleDelete = async (id) => {

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this branch',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: 'Deleting...',
        text: 'Please wait while we delete the branch.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
    });

    try {
      await axios.delete(`${API_URL + END_POINT_BRANCHES}/${id}/force`, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        }
      });
  
      Swal.fire({
        icon: 'success',
        title: 'Deleted!',
        text: 'Branch has been deleted successfully.',
      });
      // Filter out the deleted branches from state
      setPageBranch(prev => prev.filter(branch => branch.id !== id));
  
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Failed!',
        text: error.response?.data?.message || 'Failed to delete branch.',
      });
    }
  }
  };

  // const handleEdit = (id) => {
  //   navigate(`/edit/branch/${id}`);
  // }

  const handleRestore = async (id) => {

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will be able to recover this branch',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: 'Restoring...',
        text: 'Please wait while we restore the branch.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
    });

    try {
      const response = await axios.post(`${API_URL + END_POINT_BRANCHES}/${id}/restore`,{}, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        }
      });

      Swal.fire({
        icon: 'success',
        title: 'Restore!',
        text: response.data?.message || 'Branch has been restored successfully.',
      });
      // Filter out the deleted branches from state
      setPageBranch(prev => prev.filter(branch => branch.id !== id));
  
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Failed!',
        text: error.response?.data?.message || 'Failed to delete branch.',
      });
    }
  }
  };

  const handleSort = (key) => {
    setSortConfig(prev => {
      if (prev.key !== key) return { key, direction: 'asc' };
      if (prev.direction === 'asc') return { key, direction: 'desc' };
      if (prev.direction === 'desc') return { key: null, direction: 'default' };
      return { key, direction: 'asc' };
    });
  };

  const sortedBranches = useMemo(() => {
    if (sortConfig.direction === 'default' || !sortConfig.key) return pageBranch;
  
    const sorted = [...pageBranch].sort((a, b) => {
      const valA = a[sortConfig.key]?.toString().toLowerCase() ?? '';
      const valB = b[sortConfig.key]?.toString().toLowerCase() ?? '';
  
      if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
      if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  
    return sorted;
  }, [pageBranch, sortConfig]);
  

  const TableRow = ({ id, name, address, status, sourceIcon, sourceIconColor })  => {

    return (
      <tr>
        <td>
          <Card.Link href="#" className="text-primary fw-bold">{id}</Card.Link>
        </td>
        <td className="fw-bold">
          <FontAwesomeIcon icon={sourceIcon} className={`icon icon-xs text-${sourceIconColor} w-30`} />
          {name}
        </td>
        <td>{address}</td>
        <td className="text-end">
        <PermissionGate module="branches" action="edit"><Button variant="link" className="p-0 text-success me-3 box-shedow-none outline-none" onClick={() => handleRestore(id)}>
          <FontAwesomeIcon icon={faTrashRestoreAlt} />
        </Button></PermissionGate>
        <PermissionGate module="branches" action="delete"><Button variant="link" className="p-0 text-danger box-shedow-none outline-none" onClick={() => handleDelete(id)}>
          <FontAwesomeIcon icon={faTrash} />
        </Button></PermissionGate>
      </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="overflow-hidden border-radius-5 mb-4">
      <Card.Body className="pb-0 p-0">
      {loading ? (
        <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '200px',
          width: '100%',
        }}
      >
        <button
          type="button"
          disabled
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#2c82d8',
            color: 'white',
            fontWeight: 'bold',
            padding: '0.5rem 1rem',
            borderRadius: '5px',
            border: 'none',
            fontWeight: "600",
            fontSize: "15px"
          }}
        >
          <svg
            style={{
              marginRight: '10px',
              height: '20px',
              width: '20px',
              animation: 'spin 1s linear infinite',
            }}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="white"
              strokeWidth="4"
              style={{ opacity: 0.25 }}
            ></circle>
            <path
              fill="white"
              style={{ opacity: 0.75 }}
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            ></path>
          </svg>
          Processing...
        </button>
    
        {/* Spinner animation keyframes */}
        <style>
          {`
            @keyframes spin {
              to {
                transform: rotate(360deg);
              }
            }
            svg {
              transform-origin: center;
            }
          `}
        </style>
      </div>
      ) : sortedBranches.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '20px', fontSize: '16px', color: '#555' }}>
          No records found
        </div>
      ) : (
        <Table responsive className="table-centered table-nowrap rounded mb-0">
          <thead className="thead-light">
            <tr>
              {/* <th className="border-0">#</th>
              <th className="border-0">Branch name</th> */}
              <th className="border-0" onClick={() => handleSort('id')} style={{ cursor: 'pointer' }}>
                #
                {sortConfig.key === 'id' && (sortConfig.direction === 'asc' ? '⇧' : sortConfig.direction === 'desc' ? '⇩' : '⇅')}
              </th>
              <th className="border-0" onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>
                Branch name
                {sortConfig.key === 'name' && (sortConfig.direction === 'asc' ? '⇧' : sortConfig.direction === 'desc' ? '⇩' : '⇅')}
              </th>
              <th className="border-0">Address</th>
              <th className="border-0 text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            {sortedBranches.map(pt => <TableRow key={`page-traffic-${pt.id}`} {...pt} />)}
          </tbody>
        </Table>
      )}
      </Card.Body>
    </Card>
  );
};


// User Page
export const PageAdminTable = () => {

  const [pageAdmin, setPageAdmin] = useState([]);
  // const [role, setRole] = useState([]);
  const [loading, setLoading] = useState(true); // true initially to show loader
  const [originalData, setOriginalData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

  const navigate = useNavigate();
  const [impersonatingId, setImpersonatingId] = useState(null);
  const [transferUser, setTransferUser] = useState(null);
  const impersonationPending = useRef(false);

  const handleLoginAsVendor = async (id) => {
    if (impersonationPending.current) return;
    impersonationPending.current = true;
    setImpersonatingId(id);
    try {
      await startVendorSession(id);
      reloadSessionPage(Routes.DashboardOverview.path);
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Unable to log in as vendor',
        text: error.response?.data?.message || error.message || 'Please try again.',
      });
      impersonationPending.current = false;
      setImpersonatingId(null);
    }
  };

  const rawToken = sessionStorage.getItem('quotetoken');
  const token = rawToken?.replace(/^"|"$/g, '');

  const loggedInAdmin = JSON.parse(sessionStorage.getItem('quoteadmin'));
  const loggedInAdminId = loggedInAdmin?.id;
  const isSuperAdmin = (loggedInAdmin?.role_name || loggedInAdmin?.role?.name) === 'Super Admin';
  const includeSelf = !isSuperAdmin && loggedInAdmin?.account_type === 'vendor' && loggedInAdmin?.is_vendor_owner === true;
  const accountType = isSuperAdmin ? 'vendor' : 'user';
  const canTransferQuotes = isVendorOwner(loggedInAdmin);
  

  useEffect(() => {
    let active = true;
    const isCurrentRequest = () => active &&
      sessionStorage.getItem('quotetoken')?.replace(/^"|"$/g, '') === token;
    setPageAdmin([]);
    setOriginalData([]);
    setLoading(true);

    const fetchAdminlist = async () => {
      try {

        const response = await axios.get(API_URL + END_POINT_ADMIN, {
          params: {
            account_type: accountType,
            ...(includeSelf ? { include_self: 1 } : {}),
          },
          headers: {
            // 'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            Authorization: `Bearer ${token}`,
          }
        });

        if (!isCurrentRequest()) return;
        if (response.data.status && Array.isArray(response.data.data)) {
          const visibleAdmins = response.data.data.filter((admin) => {
            const owner = admin.account_type === 'vendor' && admin.is_vendor_owner === true;
            const user = admin.account_type === 'user' && !admin.is_vendor_owner;
            if ((admin.role_name || admin.role?.name) === 'Super Admin') return false;
            if (isSuperAdmin) return owner;
            return String(admin.vendor_id) === String(loggedInAdmin?.vendor_id) &&
              (user || (includeSelf && owner && String(admin.id) === String(loggedInAdminId)));
          });
          setPageAdmin(visibleAdmins);
          setOriginalData(visibleAdmins);
        }

      } catch (error) {
        if (isCurrentRequest()) console.error('Error fetching users:', error);
      } finally {
        if (isCurrentRequest()) setLoading(false);
      }

    };

    const timeout = setTimeout(() => {
      fetchAdminlist();
    });
    return () => {
      active = false;
      clearTimeout(timeout);
    };

  }, [accountType, isSuperAdmin, includeSelf, loggedInAdminId, loggedInAdmin?.vendor_id, token]);

  const handleDelete = async (id) => {

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this admin',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: 'Deleting...',
        text: 'Please wait while we delete the admin.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
    });

    try {
      await axios.delete(`${API_URL + END_POINT_ADMIN}/${id}`, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        }
      });

      Swal.fire({
        icon: 'success',
        title: 'Deleted!',
        text: 'Admin has been deleted successfully.',
      });
      // Filter out the deleted admin from state
      setPageAdmin(prev => prev.filter(admin => admin.id !== id));

    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Failed!',
        text: error.response?.data?.message || 'Failed to delete admin.',
      });
    }
  }
  };

  const handleEdit = (id) => {
    navigate(`/edit/admin/${id}`);
  }

  const handleSort = (key) => {
    setSortConfig(prev => {
      let direction = 'asc';
      if (prev.key === key && prev.direction === 'asc') direction = 'desc';
      else if (prev.key === key && prev.direction === 'desc') {
        // back to default
        setPageAdmin(originalData);
        return { key: null, direction: null };
      }

      const sorted = [...pageAdmin].sort((a, b) => {
        let aValue = a[key];
        let bValue = b[key];

        // For nested role.name
        if (key === 'role') {
          aValue = a.role?.name || '';
          bValue = b.role?.name || '';
        }

        if (typeof aValue === 'string') {
          aValue = aValue.toLowerCase();
          bValue = bValue.toLowerCase();
        }

        if (aValue < bValue) return direction === 'asc' ? -1 : 1;
        if (aValue > bValue) return direction === 'asc' ? 1 : -1;
        return 0;
      });

      setPageAdmin(sorted);
      return { key, direction };
    });
  };

  const SortIcon = ({ direction }) => {
    if (!direction) return null;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ marginLeft: '5px' }}
      >
        <circle cx="12" cy="12" r="10"></circle>
        <polyline points="12 8 8 12 12 16"></polyline>
        <line x1="16" y1="12" x2="8" y2="12"></line>
      </svg>
    );
  };

  const TableRow = ({ index, id, name, email, phone, username, role, role_name, vendor_id, is_vendor_owner, account_type, sourceIcon, sourceIconColor}) => {

    const isCurrentUser = String(id) === String(loggedInAdminId);

    const loginUserRole = String(loggedInAdmin?.role_name || loggedInAdmin?.role?.name || "").trim();
    const isLoggedInSuperAdmin = loginUserRole === "Super Admin";
    const protectedRolesForNonSuperAdmin = ["Super Admin", "Admin", "Internal Sales"];
    const isTargetSuperAdmin = role?.name === "Super Admin" || role_name === "Super Admin";

    const targetOwner = is_vendor_owner === true;
    const isSuperAdminVendorRow = isLoggedInSuperAdmin && account_type === 'vendor' && targetOwner;
    const disableDelete = isCurrentUser || isTargetSuperAdmin || (!isLoggedInSuperAdmin && targetOwner) || !hasUserPermission('users', 'delete');
    const canEdit = isCurrentUser || (!isTargetSuperAdmin && (isLoggedInSuperAdmin || !targetOwner) && hasUserPermission('users', 'edit'));
    const canEditVendor = isSuperAdminVendorRow && !isTargetSuperAdmin && hasUserPermission('users', 'edit');

    return (
      <tr>
        <td>
          <Card.Link href="#" className="text-primary fw-bold">{sortConfig.direction === 'desc' && sortConfig.key === 'serial' 
            ? pageAdmin.length - index 
            : index + 1}
          </Card.Link>
        </td>
        <td className="fw-bold">
          <FontAwesomeIcon icon={sourceIcon} className={`icon icon-xs text-${sourceIconColor} w-30`} />
          {name}
        </td>
        <td>{email}</td>
        <td>{phone}</td>
        <td>{username}</td>
        {accountType !== 'vendor' && <td>{role?.name || role_name}</td>}
        <td className="text-end">
          {isSuperAdminVendorRow && (
            <span title={!canEditVendor ? "You can't edit this vendor" : "Edit vendor"}>
              <Button
                variant="link"
                className="p-0 text-success me-3 box-shedow-none outline-none"
                onClick={() => canEditVendor && handleEdit(id)}
                disabled={!canEditVendor}
                aria-label={`Edit vendor ${name}`}
                style={{ cursor: canEditVendor ? "pointer" : "not-allowed", opacity: canEditVendor ? 1 : 0.5 }}
              >
                <FontAwesomeIcon icon={faEdit} />
              </Button>
            </span>
          )}
          {isLoggedInSuperAdmin && !isCurrentUser && !isTargetSuperAdmin && vendor_id &&
            account_type === 'vendor' && targetOwner &&
            (role?.name || role_name) && !readSuperAdminSession() && (
            <Button
              type="button"
              variant="outline-primary"
              size="sm"
              className="me-3"
              aria-label={`Login as vendor ${name}`}
              onClick={() => handleLoginAsVendor(id)}
              disabled={impersonatingId !== null}
            >
              {impersonatingId === id ? 'Logging in...' : 'Login as vendor'}
            </Button>
          )}
          {!isSuperAdminVendorRow && <>
          <span title={!canEdit ? "You can't edit this user" : ""}>
            <Button
              variant="link"
              className="p-0 text-success me-3 box-shedow-none outline-none"
              onClick={() => canEdit && handleEdit(id)}
              disabled={!canEdit}
              style={{ cursor: canEdit ? "pointer" : "not-allowed", opacity: canEdit ? 1 : 0.5 }}
            >
              <FontAwesomeIcon icon={faEdit} />
            </Button>
          </span>

          {canTransferQuotes && (
            <span title="Transfer quotes from this user">
              <Button
                variant="link"
                className="p-0 text-primary me-3 box-shedow-none outline-none"
                onClick={() => setTransferUser({ id, name })}
                aria-label={`Transfer quotes from ${name}`}
              >
                <FontAwesomeIcon icon={faExchangeAlt} />
              </Button>
            </span>
          )}

          <span title={disableDelete ? "You cannot delete this " : ""}>
            <Button
              variant="link"
              className="p-0 text-danger box-shedow-none outline-none"
              onClick={() => !disableDelete && handleDelete(id)}
              disabled={disableDelete}
              style={{ cursor: disableDelete ? "not-allowed" : "pointer", opacity: disableDelete ? 0.5 : 1 }}
            >
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </span>
          </>}
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="overflow-hidden border-radius-5 mb-4">
      <Card.Body className="pb-0 p-0">
      {loading ? (
        <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '200px',
          width: '100%',
        }}
      >
        <button
          type="button"
          disabled
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#2c82d8',
            color: 'white',
            fontWeight: 'bold',
            padding: '0.5rem 1rem',
            borderRadius: '5px',
            border: 'none',
            fontWeight: "600",
            fontSize: "15px"
          }}
        >
          <svg
            style={{
              marginRight: '10px',
              height: '20px',
              width: '20px',
              animation: 'spin 1s linear infinite',
            }}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="white"
              strokeWidth="4"
              style={{ opacity: 0.25 }}
            ></circle>
            <path
              fill="white"
              style={{ opacity: 0.75 }}
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            ></path>
          </svg>
          Processing...
        </button>
    
        {/* Spinner animation keyframes */}
        <style>
          {`
            @keyframes spin {
              to {
                transform: rotate(360deg);
              }
            }
            svg {
              transform-origin: center;
            }
          `}
        </style>
      </div>
      ) : (
        <Table responsive className="table-centered table-nowrap rounded mb-0">
          <thead className="thead-light">
            <tr>
              {/* <th className="border-0" onClick={() => handleSort('id')} style={{cursor: 'pointer'}}>
                # {sortConfig.key === 'name' && (sortConfig.direction === 'asc' ? '⇧' : sortConfig.direction === 'desc' ? '⇩' : '⇅')}
              </th> */}
              <th
                className="border-0"
                style={{ cursor: 'pointer' }}
                onClick={() => handleSort('serial')}
              >
                #
                {sortConfig.key === 'serial' && (sortConfig.direction === 'asc' ? ' 🔼' : sortConfig.direction === 'desc' ? ' 🔽' : '')}
              </th>
              {/* <th className="border-0">Name</th> */}
              <th className="border-0" onClick={() => handleSort('name')} style={{cursor: 'pointer'}}>
                Name {sortConfig.key === 'name' && (sortConfig.direction === 'asc' ? '🔼' : sortConfig.direction === 'desc' ? '🔽' : '')}
              </th>
              {/* <th className="border-0">email</th> */}
              <th className="border-0" onClick={() => handleSort('email')} style={{cursor: 'pointer'}}>
                Email {sortConfig.key === 'email' && (sortConfig.direction === 'asc' ? '🔼' : sortConfig.direction === 'desc' ? '🔽' : '')}
              </th>
              {/* <th className="border-0">Phone</th> */}
              <th className="border-0" onClick={() => handleSort('phone')} style={{cursor: 'pointer'}}>
                Phone {sortConfig.key === 'phone' && (sortConfig.direction === 'asc' ? '🔼' : sortConfig.direction === 'desc' ? '🔽' : '')}
              </th>
              {/* <th className="border-0">Username</th> */}
              <th className="border-0" onClick={() => handleSort('username')} style={{cursor: 'pointer'}}>
                Username {sortConfig.key === 'username' && (sortConfig.direction === 'asc' ? '🔼' : sortConfig.direction === 'desc' ? '🔽' : '')}
              </th>
              {/* <th className="border-0">Role</th> */}
              {accountType !== 'vendor' && (
                <th className="border-0" onClick={() => handleSort('role')} style={{cursor: 'pointer'}}>
                  Role {sortConfig.key === 'role' && (sortConfig.direction === 'asc' ? '🔼' : sortConfig.direction === 'desc' ? '🔽' : '')}
                </th>
              )}
              <th className="border-0 text-end">Actions</th>
            </tr>
          </thead>
          {/* <tbody>
            {pageAdmin.map(pt => <TableRow key={`page-traffic-${pt.id}`} {...pt} />)}
          </tbody> */}
          <tbody>
            {pageAdmin.map((pt, index) => (
              <TableRow key={`page-traffic-${pt.id}`} index={index} {...pt} />
            ))}
            {pageAdmin.length === 0 && (
              <tr><td colSpan={accountType === 'vendor' ? 6 : 7} className="text-center py-4 text-muted">{accountType === 'vendor' ? 'No Vendors Found' : 'No Users Found'}</td></tr>
            )}
          </tbody>
        </Table>
      )}
      </Card.Body>
      <QuoteTransferModal
        show={Boolean(transferUser)}
        onHide={() => setTransferUser(null)}
        token={token}
        users={pageAdmin}
        sourceUser={transferUser}
      />
    </Card>
  );
};


// role page
export const PageRoleTable = ({ refreshKey = 0, onEditRole }) => {

  const [pageRole, setRole] = useState([]);
  const [loading, setLoading] = useState(true); // true initially to show loader
  const [sortBy, setSortBy] = useState(null); // 'id' | 'name' | null
  const [sortOrder, setSortOrder] = useState('none'); // 'none' | 'asc' | 'desc'
  const [originalData, setOriginalData] = useState([]); // To store original unsorted data

  const navigate = useNavigate();
  
  const rawToken = sessionStorage.getItem('quotetoken');
  const token = rawToken?.replace(/^"|"$/g, '');

  const loggedInAdmin = JSON.parse(sessionStorage.getItem('quoteadmin'));

  useEffect(() => {
    let active = true;
    setLoading(true);
    const fetchRolelist = async () => {
      try {

        const response = await axios.get(API_URL + END_POINT_ROLES, {
          headers: {
            // 'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            Authorization: `Bearer ${token}`,
          }
        });

        if (active && response.data.status && Array.isArray(response.data.data)) {
          setRole(response.data.data);
          setOriginalData(response.data.data);
          setSortOrder('none');
          setSortBy(null);
        }

      } catch (error) {
        console.error('Error fetching tasks:', error);
      } finally {
        if (active) setLoading(false);
      }

    };

    const timeout = setTimeout(() => {
      fetchRolelist();
    });
    return () => { active = false; clearTimeout(timeout); };

  }, [refreshKey, token]);

  const handleDelete = async (id) => {

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this role',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: 'Deleting...',
        text: 'Please wait while we delete the role.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
    });

    try {
      await axios.delete(`${API_URL + END_POINT_ROLES}/${id}`, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        }
      });
  
      Swal.fire({
        icon: 'success',
        title: 'Deleted!',
        text: 'Role has been deleted successfully.',
      });
      // Filter out the deleted role from state
      setRole(prev => prev.filter(admin => admin.id !== id));
  
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Failed!',
        text: error.response?.data?.message || 'Failed to delete role.',
      });
    }
  }
  };

  const handleEdit = (id) => {
    if (!hasUserPermission('roles', 'edit')) return;
    if (onEditRole) {
      onEditRole(id);
      return;
    }
    navigate(`/edit/role/${id}`);
  }

  const handleSort = (key) => {
    let newOrder = 'asc';
  
    if (sortBy === key && sortOrder === 'asc') {
      newOrder = 'desc';
    } else if (sortBy === key && sortOrder === 'desc') {
      newOrder = 'none';
    }
  
    let sorted;
  
    if (newOrder === 'none') {
      sorted = [...originalData];
      setSortBy(null);
    } else {
      sorted = [...pageRole].sort((a, b) => {
        if (key === 'name') {
          return newOrder === 'asc'
            ? a.name.localeCompare(b.name)
            : b.name.localeCompare(a.name);
        } else if (key === 'id') {
          return newOrder === 'asc' ? a.id - b.id : b.id - a.id;
        }
        return 0;
      });
      setSortBy(key);
    }
  
    setSortOrder(newOrder);
    setRole(sorted);
  };
  


  const TableRow = ({ index, id, name, sourceIcon, role, sourceIconColor}) => {

    const isRowSuperOrAdmin = role?.name === "Admin" || role?.name === "Super Admin";
    const isLoggedInSuperOrAdmin = loggedInAdmin?.role_name === "Admin" || loggedInAdmin?.role_name === "Super Admin";

    // const disableDelete = isCurrentUser || isRowSuperOrAdmin || !isLoggedInSuperOrAdmin;
    const disableEdit = !hasUserPermission('roles', 'edit');

    const isRowSuperOrAdminDelete = role?.name === "Admin" || role?.name === "Super Admin" || role?.name === "Internal Sales";
    const isLoggedInSuperOrAdminDelete = loggedInAdmin?.role_name === "Admin" || loggedInAdmin?.role_name === "Super Admin" || loggedInAdmin?.role_name === "Internal Sales";

    const disableDelete = !hasUserPermission('roles', 'delete');

    return (
      <tr>
        {/* <td>
          <Card.Link href="#" className="text-primary fw-bold">{index}</Card.Link>
        </td> */}
        <td>
          <Card.Link href="#" className="text-primary fw-bold">{sortOrder === 'desc' && sortBy === 'serial' 
            ? pageRole.length - index 
            : index + 1}
          </Card.Link>
        </td>
        <td className="fw-bold">
          <FontAwesomeIcon icon={sourceIcon} className={`icon icon-xs text-${sourceIconColor} w-30`} />
          {name}
        </td>
        <td className="text-end">
        {/* <Button variant="link" className="p-0 text-success me-3 box-shedow-none outline-none" onClick={() => handleEdit(id)}>
          <FontAwesomeIcon icon={faEdit} />
        </Button>
        <Button variant="link" className="p-0 text-danger box-shedow-none outline-none" onClick={() => handleDelete(id)}>
          <FontAwesomeIcon icon={faTrash} />
        </Button> */}
        <span title={disableEdit ? "You can't edit this" : ""}>
          <PermissionGate module="roles" action="edit"><Button
              aria-label="Edit"
            variant="link"
            className="p-0 text-success me-3 box-shedow-none outline-none"
            // onClick={() => handleEdit(id)}
            onClick={() => !disableEdit && handleEdit(id)}
            // disabled={id !== loggedInAdminId}
            disabled={disableEdit}
            style={{ cursor: disableEdit ? "not-allowed" : "pointer", opacity: disableEdit ? 0.5 : 1 }}
          >
            <FontAwesomeIcon icon={faEdit} />
          </Button></PermissionGate>
        </span>

        <span title={disableDelete ? "You can't delete this " : ""}>
          <PermissionGate module="roles" action="delete"><Button
            variant="link"
            className="p-0 text-danger box-shedow-none outline-none"
            onClick={() => !disableDelete && handleDelete(id)}
            disabled={disableDelete}
            style={{ cursor: disableDelete ? "not-allowed" : "pointer", opacity: disableDelete ? 0.5 : 1 }}
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button></PermissionGate>
        </span>
      </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="overflow-hidden border-radius-5 mb-4">
      <Card.Body className="pb-0 p-0">
      {loading ? (
        <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '200px',
          width: '100%',
        }}
      >
        <button
          type="button"
          disabled
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#2c82d8',
            color: 'white',
            fontWeight: 'bold',
            padding: '0.5rem 1rem',
            borderRadius: '5px',
            border: 'none',
            fontWeight: "600",
            fontSize: "15px"
          }}
        >
          <svg
            style={{
              marginRight: '10px',
              height: '20px',
              width: '20px',
              animation: 'spin 1s linear infinite',
            }}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="white"
              strokeWidth="4"
              style={{ opacity: 0.25 }}
            ></circle>
            <path
              fill="white"
              style={{ opacity: 0.75 }}
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            ></path>
          </svg>
          Processing...
        </button>
    
        {/* Spinner animation keyframes */}
        <style>
          {`
            @keyframes spin {
              to {
                transform: rotate(360deg);
              }
            }
            svg {
              transform-origin: center;
            }
          `}
        </style>
      </div>
      ) : (
        <Table responsive className="table-centered table-nowrap rounded mb-0">
          <thead className="thead-light">
            <tr>
              {/* <th className="border-0">#</th>
              <th className="border-0">Role name</th> */}
              {/* <th className="border-0" style={{ cursor: 'pointer' }} onClick={() => handleSort('id')}>
                #
                {sortBy === 'id' && (sortOrder === 'asc' ? ' 🔼' : sortOrder === 'desc' ? ' 🔽' : '')}
              </th> */}
              <th
                className="border-0"
                style={{ cursor: 'pointer' }}
                onClick={() => handleSort('serial')}
              >
                #
                {sortBy === 'serial' && (sortOrder === 'asc' ? ' 🔼' : sortOrder === 'desc' ? ' 🔽' : '')}
              </th>
              <th className="border-0" style={{ cursor: 'pointer' }} onClick={() => handleSort('name')}>
                Role name
                {sortBy === 'name' && (sortOrder === 'asc' ? ' 🔼' : sortOrder === 'desc' ? ' 🔽' : '')}
              </th>
              <th className="border-0 text-end">Actions</th>
            </tr>
          </thead>
          {/* <tbody>
            {pageRole.map(pt => <TableRow key={`page-traffic-${pt.id}`} {...pt} />)}
          </tbody> */}
          <tbody>
            {pageRole.map((pt, index) => (
              <TableRow 
                key={`page-traffic-${pt.id}`} 
                index={index} // ✅ Display serial number
                {...pt} 
              />
            ))}
          </tbody>
        </Table>
      )}
      </Card.Body>
    </Card>
  );
};


// Quote page
export const PageQuoteTable = QuoteListingTable;

export const PagePrincipalTable = ({ refreshKey = 0, onEditPrincipal }) => {

  const [pagePrincipal, setPrincipal] = useState([]);
  const [loading, setLoading] = useState(true); // true initially to show loader
  const [sortOrder, setSortOrder] = useState('none'); // 'none' | 'asc' | 'desc'
  const [originalCategory, setOriginalCategory] = useState([]);
  const [sortBy, setSortBy] = useState(null);


  const navigate = useNavigate();
  
  const rawToken = sessionStorage.getItem('quotetoken');
  const token = rawToken?.replace(/^"|"$/g, '');

  // const loggedInSuperAdmin = JSON.parse(sessionStorage.getItem('quoteadmin'));
  const loggedInAdmin = JSON.parse(sessionStorage.getItem('quoteadmin'));

  
  useEffect(() => {
    let active = true;
    setLoading(true);
    const fetchPrincipallist = async () => {
      try {
        const response = await axios.get(API_URL + END_POINT_PRINCIPAL, {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          }
        });
        // if (response.data.status && Array.isArray(response.data.data)) {
        //   setPrincipal(response.data.data);
        //   setOriginalCategory(response.data.data); // Save original
        // }
        if (active && response.data.status && Array.isArray(response.data.data)) {
          const activePrincipal = response.data.data.filter(principal => principal.deleted_at === null);
          setPrincipal(activePrincipal);
          setOriginalCategory(activePrincipal);
          setSortOrder('none');
          setSortBy(null);
        }
      } catch (error) {
        console.error('Error fetching tasks:', error);
      } finally {
        if (active) setLoading(false);
      }
    };
  
    const timeout = setTimeout(() => {
      fetchPrincipallist();
    });
  
    return () => { active = false; clearTimeout(timeout); };
  }, [refreshKey, token]);


  // const handleSort = (key) => {
  //   let newOrder = 'asc';
  
  //   if (sortBy === key && sortOrder === 'asc') {
  //     newOrder = 'desc';
  //   } else if (sortBy === key && sortOrder === 'desc') {
  //     newOrder = 'none';
  //   }
  
  //   let sorted;
  
  //   if (newOrder === 'none') {
  //     sorted = [...originalCategory];
  //     setSortBy(null);
  //   } else {
  //     sorted = [...pagePrincipal].sort((a, b) => {
  //       if (key === 'name') {
  //         return newOrder === 'asc' ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name);
  //       } else if (key === 'id') {
  //         return newOrder === 'asc' ? a.id - b.id : b.id - a.id;
  //       }
  //       return 0;
  //     });
  //     setSortBy(key);
  //   }
  
  //   setSortOrder(newOrder);
  //   setPrincipal(sorted);
  // };

 const handleSort = (key) => {
  let newOrder = 'asc';

  if (sortBy === key && sortOrder === 'asc') {
    newOrder = 'desc';
  } else if (sortBy === key && sortOrder === 'desc') {
    newOrder = 'none';
  }

  let sorted;

  if (newOrder === 'none') {
    // Reset to original order
    sorted = [...originalCategory];
    setSortBy(null);
  } else {
    if (key === 'serial') {
      // Sort based on serial: simply reverse or keep the order
      sorted = newOrder === 'asc' ? [...originalCategory] : [...originalCategory].slice().reverse();
    } else if (key === 'name') {
      sorted = [...pagePrincipal].sort((a, b) =>
        newOrder === 'asc' ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name)
      );
    }
    setSortBy(key);
  }

  setSortOrder(newOrder);
  setPrincipal(sorted);
};

  const handleDelete = async (id) => {

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this principal',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: 'Deleting...',
        text: 'Please wait while we delete the principal.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
    });

    try {
      await axios.delete(`${API_URL + END_POINT_PRINCIPAL}/${id}`, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        }
      });
  
      Swal.fire({
        icon: 'success',
        title: 'Deleted!',
        text: 'Principal has been deleted successfully.',
      });
      // Filter out the deleted Principal from state
      setPrincipal(prev => prev.filter(principal => principal.id !== id));
  
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Failed!',
        text: error.response?.data?.message || 'Failed to delete principal.',
      });
    }
  }
  };

  const handleEdit = (id) => {
    if (!hasUserPermission('principals', 'edit')) return;
    if (onEditPrincipal) {
      onEditPrincipal(id);
      return;
    }
    navigate(`/edit/principal/${id}`);
  }


  const TableRow = ({ index, id, name, email, phone, username, role, sourceIcon,  sourceIconColor}) => {

    // const isLoggedInSuperAdmin = loggedInSuperAdmin?.role_name === "Super Admin";
    const isRowSuperOrAdmin = role?.name === "Admin" || role?.name === "Super Admin";
    const isLoggedInSuperOrAdmin = loggedInAdmin?.role_name === "Admin" || loggedInAdmin?.role_name === "Super Admin";

    const disableEdit = !hasUserPermission('principals', 'edit');

    
    const isRowSuperOrAdminDelete = role?.name === "Admin" || role?.name === "Super Admin" || role?.name === "Internal Sales";
    const isLoggedInSuperOrAdminDelete = loggedInAdmin?.role_name === "Admin" || loggedInAdmin?.role_name === "Super Admin" || loggedInAdmin?.role_name === "Internal Sales";

    const disableDelete = !hasUserPermission('principals', 'delete');

    return (
      <tr>
        <td>
          <Card.Link href="#" className="text-primary fw-bold">{sortOrder === 'desc' && sortBy === 'serial' 
            ? pagePrincipal.length - index 
            : index + 1}
          </Card.Link>
        </td>
        <td className="fw-bold">
          <FontAwesomeIcon icon={sourceIcon} className={`icon icon-xs text-${sourceIconColor} w-30`} />
          {name}
        </td>
        <td className="text-end">
          <span title={disableEdit ? "You can't edit this" : ""}>
            <PermissionGate module="principals" action="edit"><Button
              aria-label="Edit"
              variant="link"
              className="p-0 text-success me-3 box-shedow-none outline-none"
              // onClick={() => handleEdit(id)}
              onClick={() => !disableEdit && handleEdit(id)}
              // disabled={id !== loggedInAdminId}
              disabled={disableEdit}
              style={{ cursor: disableEdit ? "not-allowed" : "pointer", opacity: disableEdit ? 0.5 : 1 }}
            >
              <FontAwesomeIcon icon={faEdit} />
            </Button></PermissionGate>
          </span>

          <span title={disableDelete ? "You can't delete this " : ""}>
            <PermissionGate module="principals" action="delete"><Button
              variant="link"
              className="p-0 text-danger box-shedow-none outline-none"
              onClick={() => !disableDelete && handleDelete(id)}
              disabled={disableDelete}
              style={{ cursor: disableDelete ? "not-allowed" : "pointer", opacity: disableDelete ? 0.5 : 1 }}
            >
              <FontAwesomeIcon icon={faTrash} />
            </Button></PermissionGate>
          </span>
        {/* <Button variant="link" className="p-0 text-success me-3 box-shedow-none outline-none" onClick={() => handleEdit(id)}>
          <FontAwesomeIcon icon={faEdit} />
        </Button> */}
        {/* <Button variant="link" className="p-0 text-danger box-shedow-none outline-none" onClick={() => handleDelete(id)}>
          <FontAwesomeIcon icon={faTrash} />
        </Button> */}
        {/* {isLoggedInSuperAdmin && (
          <span title="Super Admin actions">
            <Button
              variant="link"
              className="p-0 text-danger box-shedow-none outline-none"
              onClick={() => handleDelete(id)}
              style={{ cursor: "pointer" }}
            >
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </span>
        )} */}
      </td>
      </tr>
    );
  };

  return (
  <Card border="light" className="overflow-hidden border-radius-5 mb-4">
    <Card.Body className="pb-0 p-0">
      {loading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '200px',
            width: '100%',
          }}
        >
          <button
            type="button"
            disabled
            style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#2c82d8',
              color: 'white',
              fontWeight: 'bold',
              padding: '0.5rem 1rem',
              borderRadius: '5px',
              border: 'none',
              fontWeight: "600",
              fontSize: "15px"
            }}
          >
            <svg
              style={{
                marginRight: '10px',
                height: '20px',
                width: '20px',
                animation: 'spin 1s linear infinite',
              }}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="white"
                strokeWidth="4"
                style={{ opacity: 0.25 }}
              ></circle>
              <path
                fill="white"
                style={{ opacity: 0.75 }}
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              ></path>
            </svg>
            Processing...
          </button>

        {/* Spinner animation keyframes */}
        <style>
          {`
            @keyframes spin {
              to {
                transform: rotate(360deg);
              }
            }
            svg {
              transform-origin: center;
            }
          `}
        </style>
      </div>
      ) : pagePrincipal.length === 0 ? (
        <div className="listing-empty-state" role="status">No principals Found</div>
      ) : (
        <Table responsive className="table-centered table-nowrap rounded mb-0">
          <thead className="thead-light">
            <tr>
              {/* <th className="border-0">#</th> */}
              {/* <th className="border-0">Principal name</th> */}
              {/* <th className="border-0" style={{ cursor: 'pointer' }} onClick={handleSortByName}>
              Principal name&nbsp;
              {sortOrder === 'asc' ? '🔼' : sortOrder === 'desc' ? '🔽' : ''}
            </th> */}
              {/* <th className="border-0" style={{ cursor: 'pointer' }} onClick={() => handleSort('id')}>
                #{sortBy === 'id' && (sortOrder === 'asc' ? ' 🔼' : sortOrder === 'desc' ? ' 🔽' : '')}
              </th> */}
              <th
                className="border-0"
                style={{ cursor: 'pointer' }}
                onClick={() => handleSort('serial')}
              >
                #
                {sortBy === 'serial' && (sortOrder === 'asc' ? ' 🔼' : sortOrder === 'desc' ? ' 🔽' : '')}
              </th>
              <th className="border-0" style={{ cursor: 'pointer' }} onClick={() => handleSort('name')}>
                Principal name {sortBy === 'name' && (sortOrder === 'asc' ? ' 🔼' : sortOrder === 'desc' ? ' 🔽' : '')}
              </th>
              <th className="border-0 text-end">Actions</th>
            </tr>
          </thead>
          {/* <tbody>
            {pagePrincipal.map(pt => <TableRow key={`page-traffic-${pt.id}`} {...pt} />)}
          </tbody> */}
          {/* <tbody>
            {pagePrincipal.map((pt, index) => (
              <TableRow key={`page-traffic-${pt.id}`} index={index + 1} {...pt} />
            ))}
          </tbody> */}
          <tbody>
            {pagePrincipal.map((pt, index) => (
              <TableRow key={`page-traffic-${pt.id}`} index={index} {...pt} />
            ))}
          </tbody>
        </Table>
      )}
    </Card.Body>
  </Card>
);

};


// soft deleted principal page
export const SoftPrincipalTable = () => {

  const [pagePrincipal, setPrincipal] = useState([]);
  const [loading, setLoading] = useState(true); // true initially to show loader
  const [sortOrder, setSortOrder] = useState('none'); // 'none' | 'asc' | 'desc'
  const [originalCategory, setOriginalCategory] = useState([]);
  const [sortBy, setSortBy] = useState(null);


  const navigate = useNavigate();
  
  const rawToken = sessionStorage.getItem('quotetoken');
  const token = rawToken?.replace(/^"|"$/g, '');

  
  useEffect(() => {
    const fetchPrincipallist = async () => {
      try {
        const response = await axios.get(API_URL + END_POINT_PRINCIPAL, {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          }
        });
        if (response.data.status && Array.isArray(response.data.data)) {
          const activePrincipal = response.data.data.filter(principal => principal.deleted_at !== null);
          setPrincipal(activePrincipal);
          setOriginalCategory(activePrincipal)
        }
      } catch (error) {
        console.error('Error fetching tasks:', error);
      } finally {
        setLoading(false); // hide loader in all cases
      }
    };
  
    const timeout = setTimeout(() => {
      fetchPrincipallist();
    });
  
    return () => clearTimeout(timeout);
  }, []);


  const handleSort = (key) => {
    let newOrder = 'asc';
  
    if (sortBy === key && sortOrder === 'asc') {
      newOrder = 'desc';
    } else if (sortBy === key && sortOrder === 'desc') {
      newOrder = 'none';
    }
  
    let sorted;
  
    if (newOrder === 'none') {
      sorted = [...originalCategory];
      setSortBy(null);
    } else {
      sorted = [...pagePrincipal].sort((a, b) => {
        if (key === 'name') {
          return newOrder === 'asc' ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name);
        } else if (key === 'id') {
          return newOrder === 'asc' ? a.id - b.id : b.id - a.id;
        }
        return 0;
      });
      setSortBy(key);
    }
  
    setSortOrder(newOrder);
    setPrincipal(sorted);
  };

  const handleDelete = async (id) => {

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this principal',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: 'Deleting...',
        text: 'Please wait while we permanent delete the principal.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
    });

    try {
      await axios.delete(`${API_URL + END_POINT_PRINCIPAL}/${id}/force`, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        }
      });
  
      Swal.fire({
        icon: 'success',
        title: 'Deleted!',
        text: 'Principal has been deleted successfully.',
      });
      // Filter out the deleted Principal from state
      setPrincipal(prev => prev.filter(principal => principal.id !== id));
  
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Failed!',
        text: error.response?.data?.message || 'Failed to delete principal.',
      });
    }
  }
  };

  // const handleEdit = (id) => {
  //   navigate(`/edit/principal/${id}`);
  // }
  // const handleRestore = (id) => {
  //   navigate(`/edit/principal/${id}`);
  // }

  const handleRestore = async (id) => {

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will be able to recover this principal',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: 'Restoring...',
        text: 'Please wait while we restore the principal.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
    });

    try {
      const response = await axios.post(`${API_URL + END_POINT_PRINCIPAL}/${id}/restore`, {}, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        }
      });
  
      Swal.fire({
        icon: 'success',
        title: 'Restored',
        // text: 'Principal has been restored successfully.',
        text: response.data?.message || 'Principal has been restored successfully.',
      });
      // Filter out the restore Principal from state
      setPrincipal(prev => prev.filter(principal => principal.id !== id));
  
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Failed!',
        text: error.response?.data?.message || 'Failed to restore principal.',
      });
    }
  }
  };


  const TableRow = ({ id, name, email, phone, username, role, sourceIcon,  sourceIconColor}) => {

    return (
      <tr>
        <td>
          <Card.Link href="#" className="text-primary fw-bold">{id}</Card.Link>
        </td>
        <td className="fw-bold">
          <FontAwesomeIcon icon={sourceIcon} className={`icon icon-xs text-${sourceIconColor} w-30`} />
          {name}
        </td>
        <td className="text-end">
        <PermissionGate module="principals" action="edit"><Button variant="link" className="p-0 text-success me-3 box-shedow-none outline-none" onClick={() => handleRestore(id)}>
          <FontAwesomeIcon icon={faTrashRestoreAlt} />
        </Button></PermissionGate>
        <PermissionGate module="principals" action="delete"><Button variant="link" className="p-0 text-danger box-shedow-none outline-none" onClick={() => handleDelete(id)}>
          <FontAwesomeIcon icon={faTrash} />
        </Button></PermissionGate>
      </td>
      </tr>
    );
  };

  return (
  <Card border="light" className="overflow-hidden border-radius-5 mb-4">
    <Card.Body className="pb-0 p-0">
      {loading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '200px',
            width: '100%',
          }}
        >
          <button
            type="button"
            disabled
            style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#2c82d8',
              color: 'white',
              fontWeight: 'bold',
              padding: '0.5rem 1rem',
              borderRadius: '5px',
              border: 'none',
              fontWeight: "600",
              fontSize: "15px"
            }}
          >
            <svg
              style={{
                marginRight: '10px',
                height: '20px',
                width: '20px',
                animation: 'spin 1s linear infinite',
              }}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="white"
                strokeWidth="4"
                style={{ opacity: 0.25 }}
              ></circle>
              <path
                fill="white"
                style={{ opacity: 0.75 }}
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              ></path>
            </svg>
            Processing...
          </button>

        {/* Spinner animation keyframes */}
        <style>
          {`
            @keyframes spin {
              to {
                transform: rotate(360deg);
              }
            }
            svg {
              transform-origin: center;
            }
          `}
        </style>
      </div>
      ) : pagePrincipal.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '2rem', fontSize: '1.2rem' }}>
          No records found.
        </div>
      ) : (
        <Table responsive className="table-centered table-nowrap rounded mb-0">
          <thead className="thead-light">
            <tr>
              {/* <th className="border-0">#</th> */}
              {/* <th className="border-0">Principal name</th> */}
              {/* <th className="border-0" style={{ cursor: 'pointer' }} onClick={handleSortByName}>
              Principal name&nbsp;
              {sortOrder === 'asc' ? '🔼' : sortOrder === 'desc' ? '🔽' : ''}
            </th> */}
              <th className="border-0" style={{ cursor: 'pointer' }} onClick={() => handleSort('id')}>
                #{sortBy === 'id' && (sortOrder === 'asc' ? ' 🔼' : sortOrder === 'desc' ? ' 🔽' : '')}
              </th>
              <th className="border-0" style={{ cursor: 'pointer' }} onClick={() => handleSort('name')}>
                Principal name {sortBy === 'name' && (sortOrder === 'asc' ? ' 🔼' : sortOrder === 'desc' ? ' 🔽' : '')}
              </th>
              <th className="border-0 text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            {pagePrincipal.map(pt => <TableRow key={`page-traffic-${pt.id}`} {...pt} />)}
          </tbody>
        </Table>
      )}
    </Card.Body>
  </Card>
);

};


// product page
export const PageProductCategoriesTable = ({ refreshKey = 0, onEditProductCategory }) => {

  const [pageCategory, setCategory] = useState([]);
  const [loading, setLoading] = useState(true); // true initially to show loader
  const [sortOrder, setSortOrder] = useState('none'); // none | asc | desc
  const [originalCategory, setOriginalCategory] = useState([]);
  const [idSortOrder, setIdSortOrder] = useState('none'); // none | asc | desc

  const navigate = useNavigate();

  const rawToken = sessionStorage.getItem('quotetoken');
  const token = rawToken?.replace(/^"|"$/g, '');

  const loggedInAdmin = JSON.parse(sessionStorage.getItem('quoteadmin'));

  useEffect(() => {
    let active = true;
    setLoading(true);
    const fetchCategorieslist = async () => {
      try {
        const response = await axios.get(API_URL + END_POINT_PRODUCT_CATEGORIES, {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          }
        });

        if (active && response.data.status && Array.isArray(response.data.data)) {
          setCategory(response.data.data);
          setOriginalCategory(response.data.data); // Save original
          setSortOrder('none');
          setIdSortOrder('none');
        }
      } catch (error) {
        console.error('Error fetching tasks:', error);
      } finally {
        if (active) setLoading(false);
      }
    };

    const timeout = setTimeout(() => {
      fetchCategorieslist();
    });

    return () => { active = false; clearTimeout(timeout); };
  }, [refreshKey, token]);

  const handleSortByName = () => {
    let newOrder;
    let sorted;

    if (sortOrder === 'none') {
      newOrder = 'asc';
      sorted = [...pageCategory].sort((a, b) => a.name.localeCompare(b.name));
    } else if (sortOrder === 'asc') {
      newOrder = 'desc';
      sorted = [...pageCategory].sort((a, b) => b.name.localeCompare(a.name));
    } else {
      newOrder = 'none';
      sorted = [...originalCategory];
    }
  
    setSortOrder(newOrder);
    setIdSortOrder('none'); // reset ID sort
    setCategory(sorted);
  };

  const handleSortById = () => {
    let newOrder;
    let sorted;
  
    if (idSortOrder === 'none') {
      newOrder = 'asc';
      sorted = [...pageCategory].sort((a, b) => a.id - b.id);
    } else if (idSortOrder === 'asc') {
      newOrder = 'desc';
      sorted = [...pageCategory].sort((a, b) => b.id - a.id);
    } else {
      newOrder = 'none';
      sorted = [...originalCategory];
    }
  
    setIdSortOrder(newOrder);
    setSortOrder('none'); // Reset name sort
    setCategory(sorted);
  };

  const handleDelete = async (id) => {

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this product category',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: 'Deleting...',
        text: 'Please wait while we delete the category.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
    });

    try {
      await axios.delete(`${API_URL + END_POINT_PRODUCT_CATEGORIES}/${id}`, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        }
      });
  
      Swal.fire({
        icon: 'success',
        title: 'Deleted!',
        text: 'Category has been deleted successfully.',
      });
      // Filter out the deleted category from state
      setCategory(prev => prev.filter(category => category.id !== id));
  
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Failed!',
        text: error.response?.data?.message || 'Failed to delete category.',
      });
    }
  }
  };

  const handleEdit = (id) => {
    if (!hasUserPermission('product_categories', 'edit')) return;
    if (onEditProductCategory) {
      onEditProductCategory(id);
      return;
    }
    navigate(`/edit/category/${id}`);
  }


  const TableRow = ({ index, id, name, principal_name, email, phone, username, role, sourceIcon,  sourceIconColor}) => {

    // const isRowSuperOrAdmin = role?.name === "Admin" || role?.name === "Super Admin";
    // const isLoggedInSuperOrAdmin = loggedInAdmin?.role_name === "Admin" || loggedInAdmin?.role_name === "Super Admin";
    const isRowSuperOrAdmin = role?.name === "Admin" || role?.name === "Super Admin" || role?.name === "Internal Sales";
    const isLoggedInSuperOrAdmin = loggedInAdmin?.role_name === "Admin" || loggedInAdmin?.role_name === "Super Admin" || loggedInAdmin?.role_name === "Internal Sales";

    // const disableDelete = isCurrentUser || isRowSuperOrAdmin || !isLoggedInSuperOrAdmin;
    const disableEdit = !hasUserPermission('product_categories', 'edit');
    const disableDelete = !hasUserPermission('product_categories', 'delete');

    return (
      <tr>
        {/* <td>
          <Card.Link href="#" className="text-primary fw-bold">{id}</Card.Link>
        </td> */}
        <td>
          <Card.Link href="#" className="text-primary fw-bold">{idSortOrder === 'desc' 
            ? pageCategory.length - index 
            : index + 1}
          </Card.Link>
        </td>
        <td className="fw-bold">
          <FontAwesomeIcon icon={sourceIcon} className={`icon icon-xs text-${sourceIconColor} w-30`} />
          {name}
        </td>
        <td className="fw-bold">
          <FontAwesomeIcon icon={sourceIcon} className={`icon icon-xs text-${sourceIconColor} w-30`} />
          {principal_name}
        </td>
        <td className="text-end">
        {/* <Button variant="link" className="p-0 text-success me-3 box-shedow-none outline-none" onClick={() => handleEdit(id)}>
          <FontAwesomeIcon icon={faEdit} />
        </Button>
        <Button variant="link" className="p-0 text-danger" onClick={() => handleDelete(id)}>
          <FontAwesomeIcon icon={faTrash} />
        </Button> */}
        <span title={disableEdit ? "You can't edit this" : ""}>
            <PermissionGate module="product_categories" action="edit"><Button
              aria-label="Edit"
              variant="link"
              className="p-0 text-success me-3 box-shedow-none outline-none"
              // onClick={() => handleEdit(id)}
              onClick={() => !disableEdit && handleEdit(id)}
              // disabled={id !== loggedInAdminId}
              disabled={disableEdit}
              style={{ cursor: disableEdit ? "not-allowed" : "pointer", opacity: disableEdit ? 0.5 : 1 }}
            >
              <FontAwesomeIcon icon={faEdit} />
            </Button></PermissionGate>
          </span>

          <span title={disableDelete ? "You can't delete this " : ""}>
            <PermissionGate module="product_categories" action="delete"><Button
              variant="link"
              className="p-0 text-danger box-shedow-none outline-none"
              onClick={() => !disableDelete && handleDelete(id)}
              disabled={disableDelete}
              style={{ cursor: disableDelete ? "not-allowed" : "pointer", opacity: disableDelete ? 0.5 : 1 }}
            >
              <FontAwesomeIcon icon={faTrash} />
            </Button></PermissionGate>
          </span>
      </td>
      </tr>
    );
  };

  return (
  <Card border="light" className="overflow-hidden border-radius-5 mb-4">
    <Card.Body className="pb-0 p-0">
      {loading ? (
        <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '200px',
          width: '100%',
        }}
      >
        <button
          type="button"
          disabled
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#2c82d8',
            color: 'white',
            fontWeight: 'bold',
            padding: '0.5rem 1rem',
            borderRadius: '5px',
            border: 'none',
            fontWeight: "600",
            fontSize: "15px"
          }}
        >
          <svg
            style={{
              marginRight: '10px',
              height: '20px',
              width: '20px',
              animation: 'spin 1s linear infinite',
            }}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="white"
              strokeWidth="4"
              style={{ opacity: 0.25 }}
            ></circle>
            <path
              fill="white"
              style={{ opacity: 0.75 }}
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            ></path>
          </svg>
          Processing...
        </button>
    
        {/* Spinner animation keyframes */}
        <style>
          {`
            @keyframes spin {
              to {
                transform: rotate(360deg);
              }
            }
            svg {
              transform-origin: center;
            }
          `}
        </style>
      </div>
      ) : pageCategory.length === 0 ? (
        <div className="listing-empty-state" role="status">No Product Categories Found</div>
      ) : (
        <Table responsive className="table-centered table-nowrap rounded mb-0">
          <thead className="thead-light">
            <tr>
              {/* <th className="border-0">#</th> */}
              {/* <th
                className="border-0"
                style={{ cursor: 'pointer' }}
                onClick={handleSortById}
              >
                #
                {idSortOrder === 'asc' ? ' 🔼' : idSortOrder === 'desc' ? ' 🔽' : ''}
              </th> */}
              <th
                className="border-0"
                style={{ cursor: 'pointer' }}
                onClick={() => handleSortById('serial')}
              >
                #
                {idSortOrder === 'asc' ? ' 🔼' : idSortOrder === 'desc' ? ' 🔽' : ''}
              </th>
              {/* <th className="border-0">Product Category name</th> */}
              <th className="border-0" style={{ cursor: 'pointer' }} onClick={handleSortByName}>
                Product Category name&nbsp;
                {sortOrder === 'asc' ? '🔼' : sortOrder === 'desc' ? '🔽' : ''}
              </th>
              <th className="border-0">Principal Name</th>
              <th className="border-0 text-end">Actions</th>
            </tr>
          </thead>
          {/* <tbody>
            {pageCategory.map(pt => <TableRow key={`page-traffic-${pt.id}`} {...pt} />)}
          </tbody> */}
          <tbody>
            {pageCategory.map((pt, index) => (
              <TableRow key={`page-traffic-${pt.id}`} index={index} {...pt} />
            ))}
          </tbody>
        </Table>
      )}
    </Card.Body>
  </Card>
);

};


// Industry page
export const PageIndustriesTable = ({ viewMode = "grid", refreshKey = 0, onEditIndustry }) => {

  const [pageIndustry, setIndustry] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedIds, setExpandedIds] = useState({});
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'default' });
  const [searchQuery, setSearchQuery] = useState('');

  const loggedInAdmin = JSON.parse(sessionStorage.getItem('quoteadmin'));

  const isRowSuperOrAdmin = (role) => role?.name === "Admin" || role?.name === "Super Admin" || role?.name === "Internal Sales";
  const isLoggedInSuperOrAdmin = loggedInAdmin?.role_name === "Admin" || loggedInAdmin?.role_name === "Super Admin" || loggedInAdmin?.role_name === "Internal Sales";
  const canEditOrDelete = (role) => !isRowSuperOrAdmin(role) && isLoggedInSuperOrAdmin;

  const navigate = useNavigate();

  const rawToken = sessionStorage.getItem('quotetoken');
  const token = rawToken?.replace(/^"|"$/g, '');

  useEffect(() => {
    let active = true;
    setLoading(true);
    const fetchIndustrylist = async () => {
      try {
        const response = await axios.get(API_URL + END_POINT_INDUSTRIES, {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          }
        });

        if (active && response.data.status && Array.isArray(response.data.data)) {
          setIndustry(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching industry:', error);
      } finally {
        if (active) setLoading(false);
      }
    };

    const timeout = setTimeout(() => {
      fetchIndustrylist();
    });

    return () => { active = false; clearTimeout(timeout); };
  }, [refreshKey, token]);

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this Industry',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: 'Deleting...',
        text: 'Please wait while we delete the Industry.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      try {
        await axios.delete(`${API_URL + END_POINT_INDUSTRIES}/${id}`, {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          }
        });

        Swal.fire({
          icon: 'success',
          title: 'Deleted!',
          text: 'Industry has been deleted successfully.',
        });

        setIndustry(prev => {
          const isParent = prev.some(ind => ind.id === id);
          if (isParent) {
            return prev.filter(ind => ind.id !== id);
          }

          return prev.map(parent => ({
            ...parent,
            child_industry: parent.child_industry?.filter(child => child.id !== id) || [],
          }));
        });
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Failed!',
          text: error.response?.data?.message || 'Failed to delete Industry.',
        });
      }
    }
  };

  const handleEdit = (id) => {
    if (!hasUserPermission('industries', 'edit')) return;
    if (onEditIndustry) {
      onEditIndustry(id);
      return;
    }
    navigate(`/edit/industries/${id}`);
  };

  const toggleShowAll = (id) => {
    setExpandedIds((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        const nextDirection = prev.direction === 'default' ? 'asc' : prev.direction === 'asc' ? 'desc' : 'default';
        return { key, direction: nextDirection };
      }
      return { key, direction: 'asc' };
    });
  };

  const sortedIndustries = useMemo(() => {
    const sorted = [...pageIndustry];
    const { key, direction } = sortConfig;

    if (direction === 'default' || !key) return sorted;

    if (key === 'serial') {
      return direction === 'desc' ? [...sorted].reverse() : sorted;
    }

    if (key === 'name') {
      sorted.sort((a, b) => {
        const valA = a.name?.toLowerCase() ?? '';
        const valB = b.name?.toLowerCase() ?? '';
        if (valA < valB) return direction === 'asc' ? -1 : 1;
        if (valA > valB) return direction === 'asc' ? 1 : -1;
        return 0;
      });
    }

    return sorted;
  }, [pageIndustry, sortConfig]);

  const filteredIndustries = useMemo(() => {
    const query = searchQuery.trim().toLowerCase();
    if (!query) return sortedIndustries;

    return sortedIndustries.filter((industry) => {
      const nameMatch = industry.name?.toLowerCase().includes(query);
      const childMatch = (industry.child_industry || []).some((child) =>
        child.name?.toLowerCase().includes(query)
      );
      return nameMatch || childMatch;
    });
  }, [sortedIndustries, searchQuery]);

  const totalSubCount = useMemo(
    () => pageIndustry.reduce((sum, ind) => sum + (ind.child_industry?.length || 0), 0),
    [pageIndustry]
  );

  const getSortIndicator = (key) => {
    if (sortConfig.key !== key) return null;
    return sortConfig.direction === 'asc'
      ? <FontAwesomeIcon icon={faAngleUp} className="ms-1 industry-sort-icon" />
      : sortConfig.direction === 'desc'
        ? <FontAwesomeIcon icon={faAngleDown} className="ms-1 industry-sort-icon" />
        : null;
  };

  const SubSegmentTag = ({ child, compact = false }) => {
    const allowed = (hasUserPermission('industries', 'edit') || hasUserPermission('industries', 'delete'));

    return (
      <div className={`industry-tag${compact ? ' industry-tag--compact' : ''}`}>
        <span className="industry-tag__label">{child.name}</span>
        {!compact && (
          <div className="industry-tag__actions">
            <PermissionGate module="industries" action="edit"><button
              type="button"
              className="industry-tag__btn"
              onClick={() => allowed && handleEdit(child.id)}
              disabled={!allowed}
              title={allowed ? 'Edit sub-segment' : "You can't edit this"}
            >
              <FontAwesomeIcon icon={faPen} />
            </button></PermissionGate>
            <PermissionGate module="industries" action="delete"><button
              type="button"
              className="industry-tag__btn industry-tag__btn--danger"
              onClick={() => allowed && handleDelete(child.id)}
              disabled={!allowed}
              title={allowed ? 'Delete sub-segment' : "You can't delete this"}
            >
              <FontAwesomeIcon icon={faTrashAlt} />
            </button></PermissionGate>
          </div>
        )}
      </div>
    );
  };

  const IndustryGridCard = ({ industry }) => {
    const isExpanded = expandedIds[industry.id];
    const children = industry.child_industry || [];
    const visibleChildren = isExpanded ? children : children.slice(0, 4);
    const disableEdit = !hasUserPermission('industries', 'edit');
    const disableDelete = !hasUserPermission('industries', 'delete');

    return (
      <Col xs={12} sm={6} lg={4}>
        <Card className="listing-grid-card listing-grid-card--industry h-100">
          <div className="listing-grid-card__accent" />
          <Card.Body className="d-flex flex-column">
            <div className="listing-grid-card__header">
              <div className="listing-grid-card__icon-wrap">
                <FontAwesomeIcon icon={faIndustry} />
              </div>
              <div className="industry-card__title-wrap">
                <h5 className="listing-grid-card__title">{industry.name}</h5>
                <span className="industry-card__count">
                  {children.length} sub-segment{children.length !== 1 ? 's' : ''}
                </span>
              </div>
            </div>

            <div className="industry-card__segments">
              <p className="industry-card__segments-label">Sub-segments</p>
              {children.length > 0 ? (
                <div className="industry-tag-list">
                  {visibleChildren.map((child) => (
                    <SubSegmentTag key={child.id} child={child} />
                  ))}
                </div>
              ) : (
                <p className="industry-card__empty">No sub-segments added yet</p>
              )}

              {children.length > 4 && (
                <button
                  type="button"
                  className="industry-card__toggle"
                  onClick={() => toggleShowAll(industry.id)}
                >
                  {isExpanded ? 'Show less' : `View all ${children.length} sub-segments`}
                </button>
              )}
            </div>

            <ListingGridActions
              disableEdit={disableEdit}
              disableDelete={disableDelete}
              onEdit={() => !disableEdit && handleEdit(industry.id)}
              onDelete={() => !disableDelete && handleDelete(industry.id)}
            />
          </Card.Body>
        </Card>
      </Col>
    );
  };

  const TableActions = (props) => (
    <ListingGridActions className="listing-table-actions" {...props} />
  );
  const ListRow = ({ industry, index }) => {
    const children = industry.child_industry || [];
    const disableEdit = !hasUserPermission('industries', 'edit');
    const disableDelete = !hasUserPermission('industries', 'delete');
    const visibleTags = children.slice(0, 4);
    const hiddenCount = children.length - visibleTags.length;

    return (
      <tr>
        <td>
          <span className="industry-list-index">{index + 1}</span>
        </td>
        <td>
          <div className="industry-list-name">
            <span className="industry-list-name__icon">
              <FontAwesomeIcon icon={faIndustry} />
            </span>
            <span className="industry-list-name__text">{industry.name}</span>
          </div>
        </td>
        <td>
          {children.length > 0 ? (
            <div className="industry-tag-list industry-tag-list--inline">
              {visibleTags.map((child) => (
                <SubSegmentTag key={child.id} child={child} compact />
              ))}
              {hiddenCount > 0 && (
                <span className="industry-tag industry-tag--more">+{hiddenCount} more</span>
              )}
            </div>
          ) : (
            <span className="industry-list-muted">—</span>
          )}
        </td>
        <td className="text-end">
          <TableActions
            disableEdit={disableEdit}
            disableDelete={disableDelete}
            onEdit={() => !disableEdit && handleEdit(industry.id)}
            onDelete={() => !disableDelete && handleDelete(industry.id)}
          />
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="listing-panel overflow-hidden mb-4">
      <Card.Header className="listing-panel__header">
        <div className="listing-panel__meta">
          <span className="listing-panel__stat">
            <strong>{filteredIndustries.length}</strong> industries
          </span>
          <span className="listing-panel__stat">
            <strong>{totalSubCount}</strong> sub-segments
          </span>
        </div>
        <div className="listing-panel__search">
          <FontAwesomeIcon icon={faSearch} className="listing-panel__search-icon" />
          <input
            type="search"
            className="listing-panel__search-input"
            placeholder="Search industries or sub-segments..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </Card.Header>

      <Card.Body className={viewMode === "grid" ? "listing-panel__body listing-panel__body--grid" : "pb-0 p-0"}>
        {loading ? (
          <div className="listing-loader-wrap">
            <button type="button" disabled className="listing-loader-btn">
              <svg
                className="listing-loader-spinner"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="4" style={{ opacity: 0.25 }} />
                <path fill="white" style={{ opacity: 0.75 }} d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
              </svg>
              Loading industries...
            </button>
          </div>
        ) : viewMode === "grid" ? (
          filteredIndustries.length > 0 ? (
            <Row className="g-4">
              {filteredIndustries.map((industry) => (
                <IndustryGridCard key={`industry-grid-${industry.id}`} industry={industry} />
              ))}
            </Row>
          ) : (
            <div className="listing-empty-state">
              {searchQuery ? 'No industries match your search.' : 'No industries found.'}
            </div>
          )
        ) : (
          <Table responsive className="table-centered table-nowrap rounded mb-0 industry-list-table">
            <thead className="thead-light">
              <tr>
                <th
                  className="border-0 industry-list-th"
                  onClick={() => handleSort('serial')}
                >
                  # {getSortIndicator('serial')}
                </th>
                <th className="border-0 industry-list-th" onClick={() => handleSort('name')}>
                  Industry {getSortIndicator('name')}
                </th>
                <th className="border-0">Sub-segments</th>
                <th className="border-0 text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredIndustries.length > 0 ? (
                filteredIndustries.map((industry, index) => (
                  <ListRow key={`industry-list-${industry.id}`} industry={industry} index={index} />
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="text-center text-muted py-5">
                    {searchQuery ? 'No industries match your search.' : 'No industries found.'}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
};


// Department page
export const PageDepartmentsTable = ({ refreshKey = 0, onEditDepartment }) => {

  const [pagedepartment, setDepartment] = useState([]);
  
  const [loading, setLoading] = useState(true); // true initially to show loader
  const [sortOrder, setSortOrder] = useState('none'); // 'none' | 'asc' | 'desc'
  const [originalCategory, setOriginalCategory] = useState([]);
  const [sortBy, setSortBy] = useState(null); 


  const navigate = useNavigate();
  
  const rawToken = sessionStorage.getItem('quotetoken');
  const token = rawToken?.replace(/^"|"$/g, '');

  const loggedInAdmin = JSON.parse(sessionStorage.getItem('quoteadmin'));

  useEffect(() => {
    let active = true;
    setLoading(true);
    const fetchDepartmentlist = async () => {
      try {
        const response = await axios.get(API_URL + END_POINT_DEPARTMENT, {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          }
        });
  
        if (active && response.data.status && Array.isArray(response.data.data)) {
          setDepartment(response.data.data);
          setOriginalCategory(response.data.data); // Save original
          setSortOrder('none');
          setSortBy(null);
        }
      } catch (error) {
        console.error('Error fetching department:', error);
      } finally {
        if (active) setLoading(false);
      }
    };
  
    const timeout = setTimeout(() => {
      fetchDepartmentlist();
    });
  
    return () => { active = false; clearTimeout(timeout); };
  }, [refreshKey, token]);


  // const handleSort = (key) => {
  //   let newOrder = 'asc';

  //   if (sortBy === key && sortOrder === 'asc') {
  //     newOrder = 'desc';
  //   } else if (sortBy === key && sortOrder === 'desc') {
  //     newOrder = 'none';
  //   }

  //   let sorted;

  //   if (newOrder === 'none') {
  //     sorted = [...originalCategory];
  //     setSortBy(null);
  //   } else {
  //     sorted = [...pagedepartment].sort((a, b) => {
  //       if (key === 'name') {
  //         return newOrder === 'asc' ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name);
  //       } else if (key === 'id') {
  //         return newOrder === 'asc' ? a.id - b.id : b.id - a.id;
  //       }
  //       return 0;
  //     });
  //     setSortBy(key);
  //   }

  //   setSortOrder(newOrder);
  //   setDepartment(sorted);
  // };

  const handleSort = (key) => {
    let newOrder = 'asc';

    if (sortBy === key && sortOrder === 'asc') {
      newOrder = 'desc';
    } else if (sortBy === key && sortOrder === 'desc') {
      newOrder = 'none';
    }

    let sorted;

    if (newOrder === 'none') {
      sorted = [...originalCategory]; 
      setSortBy(null);
    } 
    else if (key === 'serial') {
      // Serial number sort = just reverse or reset array
      sorted = newOrder === 'asc'
        ? [...pagedepartment]          // Normal order
        : [...pagedepartment].reverse(); // Reverse order
    } 
    else if (key === 'name') {
      sorted = [...pagedepartment].sort((a, b) =>
        newOrder === 'asc' ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name)
      );
    }

    setSortOrder(newOrder);
    setSortBy(key);
    setDepartment(sorted);
  };

  const handleDelete = async (id) => {

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this Department',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: 'Deleting...',
        text: 'Please wait while we delete the Department.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
    });

    try {
      await axios.delete(`${API_URL + END_POINT_DEPARTMENT}/${id}`, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        }
      });

      Swal.fire({
        icon: 'success',
        title: 'Deleted!',
        text: 'Department has been deleted successfully.',
      });
      // Filter out the deleted department from state
      setDepartment(prev => prev.filter(department => department.id !== id));

    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Failed!',
        text: error.response?.data?.message || 'Failed to delete Department.',
      });
    }
  }
  };

  const handleEdit = (id) => {
    if (!hasUserPermission('departments', 'edit')) return;
    if (onEditDepartment) {
      onEditDepartment(id);
      return;
    }
    navigate(`/edit/departments/${id}`);
  }

  const TableRow = ({ index, id, name, sourceIcon, role, sourceIconColor}) => {

    // const isRowSuperOrAdmin = role?.name === "Admin" || role?.name === "Super Admin";
    // const isLoggedInSuperOrAdmin = loggedInAdmin?.role_name === "Admin" || loggedInAdmin?.role_name === "Super Admin";
    const isRowSuperOrAdmin = role?.name === "Admin" || role?.name === "Super Admin" || role?.name === "Internal Sales";
    const isLoggedInSuperOrAdmin = loggedInAdmin?.role_name === "Admin" || loggedInAdmin?.role_name === "Super Admin" || loggedInAdmin?.role_name === "Internal Sales";

    // const disableDelete = isCurrentUser || isRowSuperOrAdmin || !isLoggedInSuperOrAdmin;
    const disableEdit = !hasUserPermission('departments', 'edit');
    const disableDelete = !hasUserPermission('departments', 'delete');

    return (
      <tr>
        {/* <td>
          <Card.Link href="#" className="text-primary fw-bold">{index}</Card.Link>
        </td> */}
        <td>
          <Card.Link href="#" className="text-primary fw-bold">
            {sortOrder === 'desc' && sortBy === 'serial'
              ? pagedepartment.length - index   // Reverse numbering for Desc
              : index + 1                       // Normal numbering for Asc or default
            }
          </Card.Link>
        </td>
        <td className="fw-bold">
          <FontAwesomeIcon icon={sourceIcon} className={`icon icon-xs text-${sourceIconColor} w-30`} />
          {name}
        </td>
        <td className="text-end">
        {/* <Button variant="link" className="p-0 text-success me-3 box-shedow-none outline-none" onClick={() => handleEdit(id)}>
          <FontAwesomeIcon icon={faEdit} />
        </Button>
        <Button variant="link" className="p-0 text-danger box-shedow-none outline-none" onClick={() => handleDelete(id)}>
          <FontAwesomeIcon icon={faTrash} />
        </Button> */}
          <span title={disableEdit ? "You can't edit this" : ""}>
            <PermissionGate module="departments" action="edit"><Button
              aria-label="Edit"
              variant="link"
              className="p-0 text-success me-3 box-shedow-none outline-none"
              // onClick={() => handleEdit(id)}
              onClick={() => !disableEdit && handleEdit(id)}
              // disabled={id !== loggedInAdminId}
              disabled={disableEdit}
              style={{ cursor: disableEdit ? "not-allowed" : "pointer", opacity: disableEdit ? 0.5 : 1 }}
            >
              <FontAwesomeIcon icon={faEdit} />
            </Button></PermissionGate>
          </span>

          <span title={disableDelete ? "You can't delete this " : ""}>
            <PermissionGate module="departments" action="delete"><Button
              variant="link"
              className="p-0 text-danger box-shedow-none outline-none"
              onClick={() => !disableDelete && handleDelete(id)}
              disabled={disableDelete}
              style={{ cursor: disableDelete ? "not-allowed" : "pointer", opacity: disableDelete ? 0.5 : 1 }}
            >
              <FontAwesomeIcon icon={faTrash} />
            </Button></PermissionGate>
          </span>
      </td>
      </tr>
    );
  };


  return (
  <Card border="light" className="overflow-hidden border-radius-5 mb-4">
    <Card.Body className="pb-0 p-0">
      {loading ? (
        <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '200px',
          width: '100%',
        }}
      >
        <button
          type="button"
          disabled
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#2c82d8',
            color: 'white',
            fontWeight: 'bold',
            padding: '0.5rem 1rem',
            borderRadius: '5px',
            border: 'none',
            fontWeight: "600",
            fontSize: "15px"
          }}
        >
          <svg
            style={{
              marginRight: '10px',
              height: '20px',
              width: '20px',
              animation: 'spin 1s linear infinite',
            }}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="white"
              strokeWidth="4"
              style={{ opacity: 0.25 }}
            ></circle>
            <path
              fill="white"
              style={{ opacity: 0.75 }}
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            ></path>
          </svg>
          Processing...
        </button>

        {/* Spinner animation keyframes */}
        <style>
          {`
            @keyframes spin {
              to {
                transform: rotate(360deg);
              }
            }
            svg {
              transform-origin: center;
            }
          `}
        </style>
      </div>
      ) : pagedepartment.length === 0 ? (
        <div className="listing-empty-state" role="status">No departments Found</div>
      ) : (
        <Table responsive className="table-centered table-nowrap rounded mb-0">
          <thead className="thead-light">
            <tr>
              <th className="border-0" style={{ cursor: 'pointer' }} onClick={() => handleSort('serial')}>
                #{sortBy === 'serial' && (sortOrder === 'asc' ? ' 🔼' : sortOrder === 'desc' ? ' 🔽' : '')}
              </th>
              <th className="border-0" style={{ cursor: 'pointer' }} onClick={() => handleSort('name')}>
                Department names {sortBy === 'name' && (sortOrder === 'asc' ? ' 🔼' : sortOrder === 'desc' ? ' 🔽' : '')}
              </th>
              <th className="border-0 text-end">Actions</th>
            </tr>
          </thead>
          {/* <tbody>
            {pagedepartment.map(pt => <TableRow key={`page-traffic-${pt.id}`} {...pt} />)}
          </tbody> */}
          <tbody>
            {pagedepartment.map((pt, index) => (
              <TableRow 
                key={`page-traffic-${pt.id}`} 
                index={index} // Numbering start from 1
                {...pt} 
              />
            ))}
          </tbody>
        </Table>
      )}
    </Card.Body>
  </Card>
);

};


// Dun Industry page
export const PageSubIndustriesTable = () => {

  const [pageSubIndustry, setSubIndustry] = useState([]);
  
  const [loading, setLoading] = useState(true); // true initially to show loader
  const [sortOrder, setSortOrder] = useState('none'); // 'none' | 'asc' | 'desc'
  const [originalCategory, setOriginalCategory] = useState([]);
  const [sortBy, setSortBy] = useState(null); 


  const navigate = useNavigate();
  
  const rawToken = sessionStorage.getItem('quotetoken');
  const token = rawToken?.replace(/^"|"$/g, '');


  useEffect(() => {
    const fetchSubIndustrylist = async () => {
      try {
        const response = await axios.get(API_URL + END_POINT_SUB_INDUSTRIES, {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          }
        });
  
        if (response.data.status && Array.isArray(response.data.data)) {
          setSubIndustry(response.data.data);
          setOriginalCategory(response.data); // Save original
        }
      } catch (error) {
        console.error('Error fetching industry:', error);
      } finally {
        setLoading(false); // hide loader in all cases
      }
    };
  
    const timeout = setTimeout(() => {
      fetchSubIndustrylist();
    });
  
    return () => clearTimeout(timeout);
  }, []);



  
  const handleSort = (key) => {
    let newOrder = 'asc';
  
    if (sortBy === key && sortOrder === 'asc') {
      newOrder = 'desc';
    } else if (sortBy === key && sortOrder === 'desc') {
      newOrder = 'none';
    }
  
    let sorted;
  
    if (newOrder === 'none') {
      sorted = [...originalCategory];
      setSortBy(null);
    } else {
      sorted = [...pageSubIndustry].sort((a, b) => {
        if (key === 'name') {
          return newOrder === 'asc' ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name);
        } else if (key === 'id') {
          return newOrder === 'asc' ? a.id - b.id : b.id - a.id;
        }
        return 0;
      });
      setSortBy(key);
    }
  
    setSortOrder(newOrder);
    setSubIndustry(sorted);
  };


  const handleDelete = async (id) => {

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this Sub-Industry',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: 'Deleting...',
        text: 'Please wait while we delete the Sub-Industry.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
    });

    try {
      await axios.delete(`${API_URL + END_POINT_SUB_INDUSTRIES}/${id}`, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        }
      });
  
      Swal.fire({
        icon: 'success',
        title: 'Deleted!',
        text: 'Sub-Industry has been deleted successfully.',
      });
      // Filter out the deleted Industry from state
      setSubIndustry(prev => prev.filter(Industry => Industry.id !== id));
  
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Failed!',
        text: error.response?.data?.message || 'Failed to delete Sub-Industry.',
      });
    }
  }
  };

  const handleEdit = (id) => {
    navigate(`/Edit/sub-industries/${id}`);
  }


  const TableRow = ({ id, name, sourceIcon,  sourceIconColor}) => {

    return (
      <tr>
        <td>
          <Card.Link href="#" className="text-primary fw-bold">{id}</Card.Link>
        </td>
        <td className="fw-bold">
          <FontAwesomeIcon icon={sourceIcon} className={`icon icon-xs text-${sourceIconColor} w-30`} />
          {name}
        </td>
        <td className="text-end">
        <PermissionGate module="industries" action="edit"><Button variant="link" className="p-0 text-success me-3 box-shedow-none outline-none" onClick={() => handleEdit(id)}>
          <FontAwesomeIcon icon={faEdit} />
        </Button></PermissionGate>
        <PermissionGate module="industries" action="delete"><Button variant="link" className="p-0 text-danger box-shedow-none outline-none" onClick={() => handleDelete(id)}>
          <FontAwesomeIcon icon={faTrash} />
        </Button></PermissionGate>
      </td>
      </tr>
    );
  };


  return (
  <Card border="light" className="overflow-hidden border-radius-5 mb-4">
    <Card.Body className="pb-0 p-0">
      {loading ? (
        <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '200px',
          width: '100%',
        }}
      >
        <button
          type="button"
          disabled
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#2c82d8',
            color: 'white',
            fontWeight: 'bold',
            padding: '0.5rem 1rem',
            borderRadius: '5px',
            border: 'none',
            fontWeight: "600",
            fontSize: "15px"
          }}
        >
          <svg
            style={{
              marginRight: '10px',
              height: '20px',
              width: '20px',
              animation: 'spin 1s linear infinite',
            }}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="white"
              strokeWidth="4"
              style={{ opacity: 0.25 }}
            ></circle>
            <path
              fill="white"
              style={{ opacity: 0.75 }}
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            ></path>
          </svg>
          Processing...
        </button>
    
        {/* Spinner animation keyframes */}
        <style>
          {`
            @keyframes spin {
              to {
                transform: rotate(360deg);
              }
            }
            svg {
              transform-origin: center;
            }
          `}
        </style>
      </div>
      ) : (
        <Table responsive className="table-centered table-nowrap rounded mb-0">
          <thead className="thead-light">
            <tr>
              <th className="border-0" style={{ cursor: 'pointer' }} onClick={() => handleSort('id')}>
                #{sortBy === 'id' && (sortOrder === 'asc' ? ' 🔼' : sortOrder === 'desc' ? ' 🔽' : '')}
              </th>
              <th className="border-0" style={{ cursor: 'pointer' }} onClick={() => handleSort('name')}>
                Sub Industries name {sortBy === 'name' && (sortOrder === 'asc' ? ' 🔼' : sortOrder === 'desc' ? ' 🔽' : '')}
              </th>
              <th className="border-0 text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            {pageSubIndustry.map(pt => <TableRow key={`page-traffic-${pt.id}`} {...pt} />)}
          </tbody>
        </Table>
      )}
    </Card.Body>
  </Card>
);

};


export const RankingTable = () => {
  const [pageRanking, setPageRanking] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch data from API
  useEffect(() => {
    const fetchRankingData = async () => {
      try {
        const response = await fetch('https://your-api-endpoint.com/rankings');
        if (!response.ok) {
          throw new Error('Failed to fetch ranking data');
        }
        const data = await response.json();
        setPageRanking(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchRankingData();
  }, []);

  const TableRow = (props) => {
    const {
      country,
      countryImage,
      overallRank,
      overallRankChange,
      travelRank,
      travelRankChange,
      widgetsRank,
      widgetsRankChange
    } = props;

    return (
      <tr>
        <td className="border-0">
          <Card.Link href="#" className="d-flex align-items-center">
            <Image src={countryImage} className="image-small rounded-circle me-2" />
            <div><span className="h6">{country}</span></div>
          </Card.Link>
        </td>
        <td className="fw-bold border-0">
          {overallRank ? overallRank : "-"}
        </td>
        <td className="border-0">
          <ValueChange value={overallRankChange} />
        </td>
        <td className="fw-bold border-0">
          {travelRank ? travelRank : "-"}
        </td>
        <td className="border-0">
          <ValueChange value={travelRankChange} />
        </td>
        <td className="fw-bold border-0">
          {widgetsRank ? widgetsRank : "-"}
        </td>
        <td className="border-0">
          <ValueChange value={widgetsRankChange} />
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="overflow-hidden border-radius-5 mb-4">
      <Card.Body className="pb-0 p-0">
        <Table responsive className="table-centered table-nowrap rounded mb-0">
          <thead className="thead-light">
            <tr>
              <th className="border-0">Country</th>
              <th className="border-0">All</th>
              <th className="border-0">All Change</th>
              <th className="border-0">Travel & Local</th>
              <th className="border-0">Travel & Local Change</th>
              <th className="border-0">Widgets</th>
              <th className="border-0">Widgets Change</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="7">Loading...</td></tr>
            ) : error ? (
              <tr><td colSpan="7">Error: {error}</td></tr>
            ) : (
              pageRanking.map(r => <TableRow key={`ranking-${r.id}`} {...r} />)
            )}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export const TransactionsTable = () => {
  const totalTransactions = transactions.length;

  const TableRow = (props) => {
    const { invoiceNumber, subscription, price, issueDate, dueDate, status } = props;
    const statusVariant = status === "Paid" ? "success"
      : status === "Due" ? "warning"
        : status === "Canceled" ? "danger" : "primary";

    return (
      <tr>
        <td>
          <Card.Link as={Link} to={Routes.Invoice.path} className="fw-normal">
            {invoiceNumber}
          </Card.Link>
        </td>
        <td>
          <span className="fw-normal">
            {subscription}
          </span>
        </td>
        <td>
          <span className="fw-normal">
            {issueDate}
          </span>
        </td>
        <td>
          <span className="fw-normal">
            {dueDate}
          </span>
        </td>
        <td>
          <span className="fw-normal">
            ${parseFloat(price).toFixed(2)}
          </span>
        </td>
        <td>
          <span className={`fw-normal text-${statusVariant}`}>
            {status}
          </span>
        </td>
        <td>
          <Dropdown as={ButtonGroup}>
            <Dropdown.Toggle as={Button} split variant="link" className="text-dark m-0 p-0">
              <span className="icon icon-sm">
                <FontAwesomeIcon icon={faEllipsisH} className="icon-dark" />
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item>
                <FontAwesomeIcon icon={faEye} className="me-2" /> View Details
              </Dropdown.Item>
              <Dropdown.Item>
                <FontAwesomeIcon icon={faEdit} className="me-2" /> Edit
              </Dropdown.Item>
              <Dropdown.Item className="text-danger">
                <FontAwesomeIcon icon={faTrashAlt} className="me-2" /> Remove
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="table-wrapper table-responsive shadow-sm">
      <Card.Body className="pt-0">
        <Table hover className="user-table align-items-center">
          <thead>
            <tr>
              <th className="border-bottom">#</th>
              <th className="border-bottom">Bill For</th>
              <th className="border-bottom">Issue Date</th>
              <th className="border-bottom">Due Date</th>
              <th className="border-bottom">Total</th>
              <th className="border-bottom">Status</th>
              <th className="border-bottom">Action</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map(t => <TableRow key={`transaction-${t.invoiceNumber}`} {...t} />)}
          </tbody>
        </Table>
        <Card.Footer className="px-3 border-0 d-lg-flex align-items-center justify-content-between">
          <Nav>
            <Pagination className="mb-2 mb-lg-0">
              <Pagination.Prev>
                Previous
              </Pagination.Prev>
              <Pagination.Item active>1</Pagination.Item>
              <Pagination.Item>2</Pagination.Item>
              <Pagination.Item>3</Pagination.Item>
              <Pagination.Item>4</Pagination.Item>
              <Pagination.Item>5</Pagination.Item>
              <Pagination.Next>
                Next
              </Pagination.Next>
            </Pagination>
          </Nav>
          <small className="fw-bold">
            Showing <b>{totalTransactions}</b> out of <b>25</b> entries
          </small>
        </Card.Footer>
      </Card.Body>
    </Card>
  );
};

export const CommandsTable = () => {
  const TableRow = (props) => {
    const { name, usage = [], description, link } = props;

    return (
      <tr>
        <td className="border-0" style={{ width: '5%' }}>
          <code>{name}</code>
        </td>
        <td className="fw-bold border-0" style={{ width: '5%' }}>
          <ul className="ps-0">
            {usage.map(u => (
              <ol key={u} className="ps-0">
                <code>{u}</code>
              </ol>
            ))}
          </ul>
        </td>
        <td className="border-0" style={{ width: '50%' }}>
          <pre className="m-0 p-0">{description}</pre>
        </td>
        <td className="border-0" style={{ width: '40%' }}>
          <pre><Card.Link href={link} target="_blank">Read More <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-1" /></Card.Link></pre>
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="overflow-hidden border-radius-5 mb-4">
      <Card.Body className="p-0">
        <Table responsive className="table-centered rounded" style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
          <thead className="thead-light">
            <tr>
              <th className="border-0" style={{ width: '5%' }}>Name</th>
              <th className="border-0" style={{ width: '5%' }}>Usage</th>
              <th className="border-0" style={{ width: '50%' }}>Description</th>
              <th className="border-0" style={{ width: '40%' }}>Extra</th>
            </tr>
          </thead>
          <tbody>
            {commands.map(c => <TableRow key={`command-${c.id}`} {...c} />)}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};